<script>
// import * as d3 from "d3";
import { onMount } from "svelte";
import 'mapbox-gl/dist/mapbox-gl.css';
import { showGlobalTick, infoPopup, instructions, beeSwarmData, selectedCity, selectedCityName, selectedCountry, loadedData } from "../shared/stores.js";
import {geoToH3} from "h3-js";
import geojson2h3 from 'geojson2h3';
import mapboxgl from 'mapbox-gl';
import { CSVDownloader } from 'svelte-csv';
// import SwitchSimple from './SwitchSimple.svelte';
// import ThemeSwitch from './ThemeSwitch.svelte';
import UnivariateLegend from './UnivariateLegend.svelte';
import CircleLegend from './CircleLegend.svelte';
import DoubleRangeSlider from './DoubleRangeSlider.svelte';
// import Beeswarm from './Beeswarm.svelte';
import DistPlot from './DistPlot.svelte';
import Select from 'svelte-select';
import MapTooltip from './MapTooltip.svelte';
import InfoPopup from './InfoPopup.svelte';
import Instructions from './Instructions.svelte';
import FilterMapInput from './FilterMapInput.svelte';
import { Circle2 } from 'svelte-loading-spinners';
import { selectAll, autoType, csv, scaleLinear, scaleSqrt, scaleQuantize, extent, sum, mean, max } from "d3";

// parameters
export let aggData;
export let darkMode;
export let innerWidth;
export let innerHeight;
export let metroData;
export let exampleCities;

// $: console.log("LOADED", $loadedData)
// export let mainBgColor;
// export let mainDrawColor;
// export let mainSpecialColor;
// export let mainTitleColor;
// export let mainBgColorControls;
// export let mainBorderColor;
// export let mainSpecialColorActive;
// theme

// $: console.log($infoPopup)
$: mainDrawColor = darkMode === true? "#ccc": "rgb(44, 44, 44)";
$: mainTitleColor = darkMode === true? "white": "rgb(44, 44, 44)";
// $: mainSpecialColor = darkMode === true? "#fbb61a": "#2255a4";
$: mainSpecialColor = darkMode===true?globeColors[globeColors.length-2]:globeColors[globeColors.length-3]
// $: mainSpecialColorActive = darkMode === true? "#ffe26e": "#32a5c2";
$: mainSpecialColorActive = darkMode===true?globeColors[globeColors.length-3]:globeColors[globeColors.length-4]
// $: mainBgColor = darkMode === true? "black": "rgb(248, 248, 248)"
$: mainSvgColor = darkMode === true? "#ccc": "rgb(163, 172, 173)";
$: mainBgColor = darkMode === true? "#040404": "rgb(248, 248, 248)";
$: mainBgColorControls = darkMode === true? "rgb(20, 20, 20)": "rgb(248, 248, 248)";
$: mainBgColorButtons = darkMode === true? "rgb(36, 36, 36)": "rgb(248, 248, 248)";
$: mainBorderColor = darkMode === true? "grey": "rgb(44, 44, 44)";
$: borderWidthButtons = darkMode===true?1.5:0;
$: borderWidthBoxes = darkMode===true?1:0;
$: borderWidthSearch = darkMode===true?1.5:0;
$: borderWidthTooltip = darkMode===true?1.5:0;
$: borderWidthControlsBox = darkMode===true?2:0;
$: boxShadow = "1px 1px 10px rgba(0, 0, 0, 0.2)";
// mapbox tiles styles
let mapboxglDarkStyle = 'mapbox://styles/lnicoletti/ckvzlna3h2vb215mv5hfzfbck/draft?optimize=true'
let mapboxglLightStyle = 'mapbox://styles/mapbox/light-v10?optimize=true'

// change background color if light mode is on
$: document.body.style.backgroundColor = mainBgColor
$: document.getElementById("mainContent").style.backgroundColor = mainBgColor

let loaded=false;
// radius for beeswarm
let radius = 1.5

$: themeSwitchHovered = false;
$: zoom = innerWidth>500?1.5:1.3;
$: tooltipActive = true;
$: sourceLoaded=false;
$: globeView = true;
let h3Resolution = 10
$: currentLat = null
$: latFactor = currentLat>50?1.3:currentLat>53?1.4:currentLat>55?1.6:
			   currentLat<25?0.7:currentLat<22?0.65:currentLat<20?0.6
				:1
let deets = false;
// let aggData = [];
let map;
// instructions variables
// $: instructions = true;
$: pageID = 0;
// console
$: showConsole=innerWidth>640?true:false;
// tooltip coordinates
$: eCoords = null;
$: tooltipFeatures = null;
// $: console.log(eCoords)
// $: eCoords!==null?console.log(eCoords["x"]):null;

$: fifteenMinPop=0;
$: fifteenMinProp=0;
$: totalPop=0;

// slider values
let start;
let end;
const nice = d => {
    if (!d && d !== 0) return '';
    return d.toFixed(2);
}

mapboxgl.accessToken = "pk.eyJ1IjoibG5pY29sZXR0aSIsImEiOiJjazZ1a3I5cjgwNWxtM2xxcDlva2NvaDNzIn0.xDhib2HysGYu4_oIkgHHow";

// default weights
$: entWeight=1;
$: foodWeight=1;
$: alWeight=1;
$: mobWeight=1;
$: comWeight=1;
$: healthWeight=1;
$: eduWeight=1;
$: weightSum=entWeight+foodWeight+alWeight+mobWeight+comWeight+healthWeight+eduWeight

$: entCheck=true;
$: foodCheck=true;
$: alCheck=true;
$: mobCheck=true;
$: comCheck=true;
$: healthCheck=true;
$: eduCheck=true;

// accessibility max
$: accessMax=6000

// $: selectedCity = null
// $: selectedCityName = null
// $: selectedCountry = null
$: console.log($selectedCity)
$: selectionData = null
$: countryData = aggData.filter(d=>d.CTR_MN_NM===$selectedCountry)
// initialize city data
$: cityGeojson = null
$: cityDataLen = cityGeojson!==null?cityGeojson.features.length:null
// $: console.log(cityGeojson)
// $: cityData = null
// $: console.log(aggData)
// $: console.log("fifteenMinPropNonAgg", fifteenMinProp)
// $: console.log(selectedCity)
// $: console.log("fifteenMinPropAgg", countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0])

$: options = 
		aggData.map(d=>{ return {
				value: d.ID_HDC_G0,
				label: d.UC_NM_CTR,
				country: d.CTR_MN_NM,
			}}).sort(function(a, b) {
				return a.country.localeCompare(b.country);
});
	
const groupBy = (item) => item.country;

$: cityUrls = new Map(aggData.map(d=>{
            return {
              city: d.ID_HDC_G0,
              url: `/data/${d.ID_HDC_G0}.csv`
            }
          }).map(i => [i.city, i.url])
)

function loadAndPrepareData(city) {
		
		// load data
		let data = csv(cityUrls.get(city), autoType)
		// loadedData = csv(cityUrls.get(city), autoType)

		return data
}

$: mapColors = //multiValue=== "dark"? 
					darkMode=== true? 
					// ["#542788","#998ec3","#d8daeb","#f7f7f7","#fee0b6","#f1a340","#b35806"]:
					// ["#000004","#210c4a","#57106e","#8a226a","#bc3754","#e45a31","#f98e09","#f9cb35","#fcffa4"]:
					["#000004","#1b0c41","#4a0c6b","#781c6d","#a52c60","#cf4446","#ed6925","#fb9b06","#f7d13d","#fcffa4"]:
					// ["#000004","#320a5e","#781c6d","#bc3754","#ed6925","#fbb61a","#fcffa4"]:
					// ['#94003a', '#aa404d', '#be6862', '#d18e7a', '#e3b496', '#f3dab8', '#fffff2'].reverse()
					// ["#edf8fb","#bfd3e6","#9ebcda","#8c96c6","#8c6bb1","#88419d","#6e016b"]//#404040"]
					["#ffffd9","#edf8ba","#cdebb4","#97d7b9","#5dc0c0","#32a5c2","#217fb7","#2255a4","#1e3489","#081d58"]

$: globeColors = darkMode === true?
				["#000004","#320a5e","#781c6d","#bc3754","#ed6925","#fbb61a","#fcffa4"]
				// ["#002051","#1f3e6e","#575c6e","#7f7c75","#a49d78","#d5c164","#fdea45"]
				:
				["#ffffcc","#c7e9b4","#7fcdbb","#41b6c4","#1d91c0","#225ea8","#0c2c84"]
				// ["#feebe2","#fcc5c0","#fa9fb5","#f768a1","#dd3497","#ae017e","#7a0177"]

// tooltip scale
$: accessScale = scaleQuantize([0,1],
				  					mapColors)

$: config = ({
        // lng: -87.6698,
        // lat: 41.8481,
        lng: -74.0060,
        lat: 40.7128,
        zoom: 9.5,
        fillOpacity: 0.9,
        // colorScale: accessScale.range(),
        // colorScale: ['#ffffD9', '#50BAC3', '#1A468A'],
        // colorScale: sevenColors,
        colorScale: mapColors,
		colorScaleGlobe: globeColors,
        areaThreshold: 0.75,
        mapWidth: 1100,
        mapHeight: 650,
        legendOffset: 50
})

let distanceToNorm = scaleLinear()
                        .domain([0, 6000])
                        .range([0,1])

let normToDistance = scaleLinear()
                        .domain([0,1])
                        .range([0, 6000])

// scale for population circles (it changes based on which country is selected)
$: if ($showGlobalTick===true) {
	beeSwarmData.set(metroData)
} else if (zoom>9) {
	beeSwarmData.set(countryData)
}

// $: console.log("rscale", $beeSwarmData)

// $: beeSwarmData.set(zoom<9?metroData:countryData)

$: rScale = getRscale($beeSwarmData, radius, innerWidth)
$: showCircleLegend = ($showGlobalTick===true||(showConsole===true&&zoom>=9)||$instructions===true) && $infoPopup===false && deets===false?true:false
$: heatLegendOffset = showCircleLegend===true?0.71:0.78
$: distPlotWidthRatio = innerWidth>900?0.8:innerWidth>500?0.85:innerWidth>450?0.9:0.95;
$: headerItemsMargins = innerWidth*((1-distPlotWidthRatio)/2)
// $: showGlobalTick.set(zoom<2.3?true:false);
// $: showGlobalTick = zoom<2.3&&(pageID>=4||$instructions===false)?true:false


// $: console.log("pageid", pageID)
// $: console.log("globaltick", $showGlobalTick)
// $: console.log("instructions", instructions===false)
onMount(async () => {

		// await csv("/data/access_agg.csv", autoType).then((data)=>{aggData = data})
		let mediaWidth = innerWidth
		// Create the map
		// if (!map) {
			// let randomCity = cityNames[Math.floor(Math.random()*cityNames.length)]
			// selectedCity = randomCity
			// const center = fetch(`https://api.tiles.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(randomCity)}.json?access_token=${mapboxgl.accessToken}`)
			// 		.then(response => response.json())
			// 		.then(geocoding => geocoding.features[0].center)
			// 		.then(center => map.flyTo({center}))

			map = new mapboxgl.Map({
				// container: mapContainer,
				container: "access",
				// center: [
				// 	config.lng,
				// 	config.lat,
				// ],
				center: [
					8.749280057628914,
					36.66699789702516
				],
				// zoom: config.zoom,
				zoom: zoom,
				projection: 'globe',
				maxZoom: 15,
				// minZoom: 1.3,
				// zoom: 0,
				// maxZoom:0,
				// minZoom:0,
				
				// style: 'mapbox://styles/mapbox/dark-v9',
				style:'mapbox://styles/lnicoletti/ckvzlna3h2vb215mv5hfzfbck/draft?optimize=true'
				// style:'mapbox://styles/lnicoletti/ckvzlna3h2vb215mv5hfzfbck/draft'
							
				// attributionControl: true
				});
			// map.addControl(
			// 	new MapboxGeocoder({
			// 	accessToken: mapboxgl.accessToken,
			// 	// mapboxgl: mapboxgl,
			// 	// countries: 'us'
			// 	}),
			// 	'top-left'
			// );
			// map.addControl(new mapboxgl.NavigationControl(), 'top-right'); //zoom controls

			// redraw layer on style change
			map.on('load', function() {
				// renderHexes(map, selectedCity)
				renderGlobeMap(map, aggData)
				// renderHeatmap(map, selectedCity)
				loaded=true
				// if (mediaWidth<640) {
				// 	map.addControl(new mapboxgl.FullscreenControl(), 'top-left'); //full screen controls
				// }
			})

			map.on('sourcedata', sourceCallback);
			darkMode = true;

			// log zoom level
			map.on('zoom', (e) => {
				zoom = map.getZoom();
				// console.log('zoom level', zoom);
			// event type: boxzoomstart
			});
			
							
});

function renderGlobeMap(map, data) {

		// map["scrollZoom"].disable();
		// map["dragPan"].disable();
		// load global dataset
		// console.log("This is the aggregated data", data)
		// csv("/data/access_agg.csv", autoType).then(data=>{

		let distanceToNormGlobe = scaleLinear()
						   .domain(extent(data, d=>d.mobility))
						   .range([1,0])

		const geojson = {
				"type": "FeatureCollection",
				"features": data.map(d=>{
					return {
						"type":"Feature",
						"geometry":{
							"type":"Point",
							"coordinates":[
								d.lng,
								d.lat
							]
						},
						"properties":{
							// count:d.count, 
							UC_NM_CTR:d.UC_NM_CTR,
							CTR_MN_NM:d.CTR_MN_NM,
							UC_NM_MN:d.UC_NM_MN,
							ID_HDC_G0:d.ID_HDC_G0,
							AREA:d.AREA,
							mobility:d.mobility, 
							entertainment:d.nightlife,
							food_choices:d.food_choices,
							active_living:d.active_living,
							community_space:d.community_space,
							health:d.health_wellbeing,
							mobility:d.mobility,
							education:d.education,
							accessibilityNorm: distanceToNormGlobe((d.mobility+d.nightlife+d.food_choices+d.active_living+d.community_space+d.health_wellbeing+d.education)/7),
							accessibility: (d.mobility+d.nightlife+d.food_choices+d.active_living+d.community_space+d.health_wellbeing+d.education)/7,
							fifteenPropAccess: d.fifteenPropAccess,
							P15: d.P15
						}
					}
				})
			}

		// accessMax = max(geojson.features, d=>d.properties.accessibility)
		// console.log("access max", accessMax)
		// console.log("agg", geojson)
		// console.log("agg", extent(data, d=>d.count))
		// console.log("agg", data.filter(d=>d.UC_NM_CTR==="London, United Kingdom"))
		// console.log("agg", geojson.features.filter(d=>d.properties.UC_NM_CTR==="London, United Kingdom"))

		const sourceId = `poi-agg`;
		const layerId = `${sourceId}-layer`;
		let source = map.getSource(sourceId);
		// console.log(layerId)

		// find ID of symbol layer
		const layers = map.getStyle().layers;
		// Find the index of the first symbol layer in the map style.
		let firstSymbolId;
		for (const layer of layers) {
			if (layer.type === 'symbol') {
				firstSymbolId = layer.id;
			break;
			}
		}
		
		// Add the source and layer if we haven't created them yet
		if (!source) {
			map.addSource(sourceId, {
				type: 'geojson',
				data: geojson
			});
			map.addLayer({
				id: layerId,
				source: sourceId,
				className: "world-heat",
				type: 'heatmap',
				interactive: false,
				// zoom: 0,
				// maxZoom:0,
				// minZoom:0,
				maxzoom: 5,
				paint: {
					// increase weight as diameter breast height increases
					'heatmap-weight': {
						'property': 'accessibilityNorm',
						'type': 'exponential',
						'stops': [
							[0, 0],
							[1, 1]
						]
					},
					// increase intensity as zoom level increases
					'heatmap-intensity': {
						'stops': [
							[0, 1],
							[2000, 2]
						]
					},
					// use sequential color palette to use exponentially as the weight increases
					'heatmap-color': [
						'interpolate',
						['linear'],
						['heatmap-density'],
						0, 'rgba(236,222,239,0)',
						0.2, config.colorScaleGlobe[0],
						0.3, config.colorScaleGlobe[1],
						0.4, config.colorScaleGlobe[2],
						0.5, config.colorScaleGlobe[3],
						0.6, config.colorScaleGlobe[4],
						0.7, config.colorScaleGlobe[5],
						0.8, config.colorScaleGlobe[6]
						// 0,
						// 'rgba(236,222,239,0)',
						// 0.2,
						// 'rgb(208,209,230)',
						// 0.4,
						// 'rgb(166,189,219)',
						// 0.6,
						// 'rgb(103,169,207)',
						// 0.8,
						// 'rgb(28,144,153)'
					],
					// increase radius as zoom increases
					'heatmap-radius': {
						'stops': [
							[1, 6],
							[2, 10],
							[3, 15],
							[4, 20]
						]
					},
					// increase radius as zoom increases
					'heatmap-opacity': {
						'stops': [
							[1, 1],
							[2, 0.8],
							[3, 0.7],
							[4, 0.5]
						]
					}
				}
			},
			'poi-label'
			);

			map.addLayer(
				{
				'id': 'cities-point',
				'type': 'circle',
				'source': sourceId,
				'minzoom': 4,
				'maxzoom': 9,
				'paint': {
				// increase the radius of the circle as the zoom level and dbh value increases
				'circle-radius': 10,
				// {
				// 	'property': 'P15',
				// 	'type': 'exponential', 
				// 	'stops': [
				// 	[{ zoom: 5, value: 100000 }, rScale(1000000)],
				// 	[{ zoom: 5, value: 40000000 }, rScale(40000000)],
				// 	[{ zoom: 9, value: 100000 }, rScale(1000000)],
				// 	[{ zoom: 9, value: 40000000 }, rScale(40000000)]
				// 	]
				// 	},
					// stops: [
					// [100000, rScale(500000)],
					// [40000000, rScale(40000000)]
					// ]
					// },
				// [
				// 	'let', 'data_prop', ['get', 'P15'],
				// 	[
				// 		'interpolate', ['exponential', 1], ['number', ['var', 'data_prop']],
				// 		100000, rScale(500000),
				// 		40000000, rScale(40000000)
				// 	],
				// ],
				// {
				// 'property': 'P15',
				// 'type': 'exponential', 
				// // innerWidth>1000?[radius/2, radius*5]:innerWidth>640?[radius/2.5, radius*4.5]:[radius/3, radius*3]
				// 'stops': [
				// [{ zoom: 15, value: 0 }, 2],
				// [{ zoom: 15, value: 1 }, 10],
				// [{ zoom: 22, value: 0 }, 10],
				// [{ zoom: 22, value: 1 }, 50]
				// ]
				// },
				'circle-color': `${mainSpecialColor}`,
				// 'circle-stroke-color': `${mainBgColorControls}`,
				'circle-stroke-color': `${mainSpecialColor}`,
				// 'fill-color': `${mainSpecialColor}`,
				'circle-stroke-width': 1.2,
				'circle-opacity':0.2,
				// 'circle-opacity': {
				// 	'stops': [
				// 	[14, 0],
				// 	[15, 0.5]
				// 	]
				// }
				}
				},
				'poi-label'
				);

			source = map.getSource(sourceId);
		}
		
		// Update the geojson data
		source.setData(geojson);

		map.on('mouseover', 'cities-point', (event) => {
				showTooltipGlobe(event)
			});
			
		map.on('mousemove', 'cities-point', (event) => {
				showTooltipGlobe(event)
			});

		// map.on('mouseleave', 'cities-point', (event) => {
		// 		selectAll(".mapboxgl-popup").remove()
		// 	});

		map.on('click', 'cities-point', (event) => {
			if (innerWidth<640) {
				showTooltipGlobe(event)
			} else {
				selectedCity.set(event.features[0].properties.ID_HDC_G0)
				selectedCityName.set(event.features[0].properties.UC_NM_CTR)
				selectedCountry.set(event.features[0].properties.CTR_MN_NM)
				flyToNewCity(map, $selectedCity)
			}
			
			
		});

		// }
		// )

}

function renderHeatmapCircle(map, city) {

	globeView = false;
	// console.log("rendering heatmap")
	// return new Promise(function(resolve, reject) {
		// map["scrollZoom"].enable();
		// map["dragPan"].enable();

		let weightSum = entWeight+foodWeight+alWeight+mobWeight+comWeight+healthWeight+eduWeight

		loadAndPrepareData(city)
		.then(data=> data.map(d=> ({ ...d, nightlife: d.nightlife!==undefined?d.nightlife:null, 
										mobility: d.mobility!==undefined?d.mobility:null, 
										education: d.education!==undefined?d.education:null, 
										community_space: d.community_space!==undefined?d.community_space:null, 
										health_wellbeing: d.health_wellbeing!==undefined?d.health_wellbeing:null, 
										food_choices: d.food_choices!==undefined?d.food_choices:null, 
										active_living: d.active_living!==undefined?d.active_living:null })))
		.then(data=>data.map(d=> ({ ...d, accessibility: Math.log(((entWeight*d.nightlife)+
																	(foodWeight*d.food_choices)+
																	(alWeight*d.active_living)+
																	(mobWeight*d.mobility)+
																	(comWeight*d.community_space)+
																	(healthWeight*d.health_wellbeing)+
																	(eduWeight*d.education))/weightSum),
										accessibilityRawDist: +((entWeight*d.nightlife)+
																	(foodWeight*d.food_choices)+
																	(alWeight*d.active_living)+
																	(mobWeight*d.mobility)+
																	(comWeight*d.community_space)+
																	(healthWeight*d.health_wellbeing)+
																	(eduWeight*d.education))/weightSum,
										//   accessibilityRaw: distanceToNorm(((entWeight*d.nightlife)+
										// 							(foodWeight*d.food_choices)+
										// 							(alWeight*d.active_living)+
										// 							(mobWeight*d.mobility)+
										// 							(comWeight*d.community_space)+
										// 							(healthWeight*d.health_wellbeing)+
										// 							(eduWeight*d.education))/weightSum)
																})))
			
			// normalize accessibility
			// .then(data=>data.map(d=> ({...d, accessibility: 1-normScale(d.accessibility)})))
			.then(data=> {
					let normScale = scaleLinear().domain(extent(data.filter(d=>d.accessibility!== -Infinity), d=> +d.accessibility)).range([0, 1]);
					data = data.map(d=> ({...d, accessibility: 1-normScale(d.accessibility)
											}))
					// console.log("test",data)
				return data
			})
		
			.then(data=>{
			
			// console.log("data", data)
			// console.log("data full", data.length)
			// data = data.filter(d=>d.POP_2015>=1)
			// console.log("data filtered", data.length)

			// with data
			totalPop = countryData.filter(d=>d.ID_HDC_G0 === $selectedCity)[0].P15//sum(data, d=>d.POP_2015)
			fifteenMinPop = sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015)
			fifteenMinProp = (fifteenMinPop/totalPop)*100>100?100:(fifteenMinPop/totalPop)*100
			// with agg
			// totalPop = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].P15
			// fifteenMinPop = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].fifteenPopAccess
			// fifteenMinProp = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].fifteenPropAccess

			// console.log("fifteenMinPopData", sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015))
			// console.log("fifteenMinPopAgg", fifteenMinPop)
			// console.log("fifteenMinPropData", (sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015)/totalPop)*100)
			// console.log("fifteenMinPropAgg", fifteenMinProp)
			// accessMean = mean(data, d=>d.accessibilityRawDist)
			// accessMax = max(data, d=>d.accessibilityRawDist)
			// filter data that is 5000 meters
			console.log("datapoints before 5000 filter", data.length)
			data = data.filter(d=>d.accessibilityRawDist<4000)
			console.log("datapoints after 5000 filter", data.length)

			const geojson = {
				"type": "FeatureCollection",
				"features": data.map(d=>{
					return {
						"type":"Feature",
						"geometry":{
							"type":"Point",
							"coordinates":[
								d.lng,
								d.lat
							]
						},
						"properties":{
							mobility:d.mobility, 
							entertainment:d.nightlife,
							food_choices:d.food_choices,
							active_living:d.active_living,
							community_space:d.community_space,
							health:d.health_wellbeing,
							mobility:d.mobility,
							education:d.education,
							accessibility: d.accessibility,
							accessibilityRawDist: d.accessibilityRawDist,
							population: d.POP_2015
						}
					}
				})
			}

			// console.log("data", geojson)
			console.log("total pop", totalPop)
			console.log("15 pop", fifteenMinPop)
			console.log("15 prop", fifteenMinProp)
			console.log("accessMax", accessMax)
			// console.log("heatmap rendered")

			// // load the data only if it hasnt been loaded
			// const geojson = geojson2h3.h3SetToFeatureCollection(
			// 	Object.keys(hexagons),
			// 	hex => ({mobility: hexagons[hex].mobility, 
			// 				entertainment: hexagons[hex].entertainment,
			// 				food_choices: hexagons[hex].food_choices,
			// 				active_living: hexagons[hex].active_living,
			// 				community_space: hexagons[hex].community_space,
			// 				health: hexagons[hex].health,
			// 				mobility: hexagons[hex].mobility,
			// 				education: hexagons[hex].education,
			// 				accessibility: hexagons[hex].accessibility,
			// 				population: hexagons[hex].population})
			// );

			// // remove old layers and sources to optimize render
			// map.removeLayer(`h3-hexes-layer`)
			// map.removeSource(`h3-hexes`)
			
			// const sourceId = `${city}-h3-hexes`;
			// const layerId = `${city}-${sourceId}-layer`;
			const sourceId = `h3-hexes`;
			const layerId = `${sourceId}-layer`;
			let source = map.getSource(sourceId);
			
			// Add the source and layer if we haven't created them yet
			if (!source) {
				map.addSource(sourceId, {
					type: 'geojson',
					data: geojson
				});
				map.addLayer({
					id: layerId,
					source: sourceId,
					className: "hexes",
					type: 'circle',
					interactive: false,
					// zoom: 9.5,
					// maxZoom: 12,
					minzoom: 9,
					// maxzoom: 15,
					paint: {
						
						'circle-stroke-color': 'transparent',
						'circle-color': {
							property: 'accessibility',
							stops: [
							[0.1, config.colorScale[0]],
							[0.2, config.colorScale[1]],
							[0.3, config.colorScale[2]],
							[0.4, config.colorScale[3]],
							[0.5, config.colorScale[4]],
							[0.6, config.colorScale[5]],
							[0.7, config.colorScale[6]],
							[0.9, config.colorScale[7]],
							[1, config.colorScale[9]],
							]
						},
						// 'fill-outline-color': 'rgba(0,0,0,0)',
						// increase radius as zoom increases
						
						// increase radius as zoom increases
						'circle-radius': {
							'stops': [
								[9, 0.5],
								[11, 2],
								[13, 8],
								[14, 20],
								[15, 30],
								// [18, 80]
							]
						},
						// increase radius as zoom increases
						'circle-opacity': {
							'stops': [
								[9, 0.85],
								[11, 0.7],
								[13, 0.7],
								[15, 0.5]
							]
						}
					}
				},
				"poi-label"
				// 'land'
				);
				source = map.getSource(sourceId);
			}

			// map.addLayer(
			// {
			// 'id': 'add-buildings',
			// 'source': 'composite',
			// 'source-layer': 'building',
			// 'type': 'fill',
			// 'paint' : {
			// 	'fill-color': 'blue',
			// 	'fill-opacity': 1
			// 	},
			// }, "poi-label")
			
			// Update the geojson data
			source.setData(geojson);

			// map.moveLayer(layerId, 'add-buildings')

			// find ID of symbol layer
			const layers = map.getStyle().layers;
			console.log("layers", layers)
			// Find the index of the first symbol layer in the map style.
			// for (const layer of layers) {
			// 	if (layer.type === 'fill' && layer.id !== "land" && layer.id !== "land") {
			// 		map.moveLayer("land", 'airport-label');
			// 	break;
			// 	}
			// }
			// let firstSymbolId;
			// for (const layer of layers) {
			// 	if (layer.type === 'symbol') {
			// 		firstSymbolId = layer.id;
			// 	break;
			// 	}
			// }
			
			// Update the layer paint properties, using the current config values
			// map.setPaintProperty(layerId, 'fill-color', {
			// 	property: 'accessibility',
			// 	stops: [
			// 	[0.2, config.colorScale[0]],
			// 	[0.3, config.colorScale[1]],
			// 	[0.4, config.colorScale[2]],
			// 	[0.5, config.colorScale[3]],
			// 	[0.6, config.colorScale[4]],
			// 	[0.7, config.colorScale[5]],
			// 	[0.8, config.colorScale[6]]
			// 	]
			// });
			
			// tooltip
			// map.on('click', layerId, (e) => {
			map.on('mouseover', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				showTooltip(e)
			});
			
			map.on('mousemove', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				// selectAll(".mapboxgl-popup-content").remove()
				// selectAll(".mapboxgl-popup-tip").remove()
				showTooltip(e)
			});

			map.on('click', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				showTooltip(e)
			});
				
				// Change the cursor to a pointer when
				// the mouse is over the states layer.
			map.on('mouseenter', layerId, () => {
				map.getCanvas().style.cursor = 'pointer';
			});
			
			// Change the cursor back to a pointer
			// when it leaves the states layer.
			map.on('mouseleave', layerId, () => {
				map.getCanvas().style.cursor = '';
				selectAll(".mapboxgl-popup").remove()
				eCoords = null;
				// selectAll(".mapboxgl-popup-content").remove()
				// selectAll(".mapboxgl-popup-tip").remove()
				// selectAll(".mapboxgl-popup mapboxgl-popup-anchor-top").remove()
			});
			
			// map.setPaintProperty(layerId, 'fill-opacity', config.fillOpacity);
			})

		// 	resolve()
		
		// })

		// geojson = null
}

function renderHeatmap(map, city) {

	globeView = false;
	// console.log("rendering heatmap")
	// return new Promise(function(resolve, reject) {
		// map["scrollZoom"].enable();
		// map["dragPan"].enable();

		let weightSum = entWeight+foodWeight+alWeight+mobWeight+comWeight+healthWeight+eduWeight

		loadAndPrepareData(city)
		.then(data=> data.map(d=> ({ ...d, nightlife: d.nightlife!==undefined?d.nightlife:null, 
										   mobility: d.mobility!==undefined?d.mobility:null, 
										   education: d.education!==undefined?d.education:null, 
										   community_space: d.community_space!==undefined?d.community_space:null, 
										   health_wellbeing: d.health_wellbeing!==undefined?d.health_wellbeing:null, 
										   food_choices: d.food_choices!==undefined?d.food_choices:null, 
										   active_living: d.active_living!==undefined?d.active_living:null })))
		.then(data=>data.map(d=> ({ ...d, 
										  accessibility: Math.log(((entWeight*d.nightlife)+
																	(foodWeight*d.food_choices)+
																	(alWeight*d.active_living)+
																	(mobWeight*d.mobility)+
																	(comWeight*d.community_space)+
																	(healthWeight*d.health_wellbeing)+
																	(eduWeight*d.education))/weightSum),
										//   accessibility: ((entWeight*d.nightlife)+
										// 							(foodWeight*d.food_choices)+
										// 							(alWeight*d.active_living)+
										// 							(mobWeight*d.mobility)+
										// 							(comWeight*d.community_space)+
										// 							(healthWeight*d.health_wellbeing)+
										// 							(eduWeight*d.education))/weightSum,

										  accessibilityRawDist: +((entWeight*d.nightlife)+
																	(foodWeight*d.food_choices)+
																	(alWeight*d.active_living)+
																	(mobWeight*d.mobility)+
																	(comWeight*d.community_space)+
																	(healthWeight*d.health_wellbeing)+
																	(eduWeight*d.education))/weightSum,
										//   accessibilityRaw: distanceToNorm(((entWeight*d.nightlife)+
										// 							(foodWeight*d.food_choices)+
										// 							(alWeight*d.active_living)+
										// 							(mobWeight*d.mobility)+
										// 							(comWeight*d.community_space)+
										// 							(healthWeight*d.health_wellbeing)+
										// 							(eduWeight*d.education))/weightSum)
																})))
			
			// normalize accessibility
			// .then(data=>data.map(d=> ({...d, accessibility: 1-normScale(d.accessibility)})))
			.then(data=> {
					let normScale = scaleLinear().domain(extent(data.filter(d=>d.accessibility!== -Infinity), d=> +d.accessibility)).range([0, 1]);
					data = data.map(d=> ({...d, accessibility: 1-normScale(d.accessibility)
											}))
					// console.log("test",data)
				return data
			})
		
			.then(data=>{
			
			// console.log("data", data)
			// console.log("data full", data.length)
			// data = data.filter(d=>d.POP_2015>=1)
			// console.log("data filtered", data.length)

			// with data
			totalPop = countryData.filter(d=>d.ID_HDC_G0 === $selectedCity)[0].P15//sum(data, d=>d.POP_2015)
			fifteenMinPop = sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015)
			fifteenMinProp = (fifteenMinPop/totalPop)*100>100?100:(fifteenMinPop/totalPop)*100

			loadedData.set(data)
			// with agg
			// totalPop = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].P15
			// fifteenMinPop = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].fifteenPopAccess
			// fifteenMinProp = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].fifteenPropAccess

			// console.log("fifteenMinPopData", sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015))
			// console.log("fifteenMinPopAgg", fifteenMinPop)
			// console.log("fifteenMinPropData", (sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015)/totalPop)*100)
			// console.log("fifteenMinPropAgg", fifteenMinProp)
			// accessMean = mean(data, d=>d.accessibilityRawDist)
			// accessMax = max(data, d=>d.accessibilityRawDist)
			// filter data that is 5000 meters
			// console.log("datapoints before 5000 filter", data.length)
			data = data.filter(d=>d.accessibilityRawDist<4000)
			// console.log("datapoints after 5000 filter", data.length)

			cityGeojson = {
				"type": "FeatureCollection",
				"features": data.map(d=>{
					return {
						"type":"Feature",
						"geometry":{
							"type":"Point",
							"coordinates":[
								d.lng,
								d.lat
							]
						},
						"properties":{
							mobility:d.mobility, 
							entertainment:d.nightlife,
							food_choices:d.food_choices,
							active_living:d.active_living,
							community_space:d.community_space,
							health:d.health_wellbeing,
							mobility:d.mobility,
							education:d.education,
							accessibility: d.accessibility,
							accessibilityRawDist: d.accessibilityRawDist,
							population: d.POP_2015
						}
					}
				})
			}

			// console.log("data", geojson)
			// console.log("total pop", totalPop)
			// console.log("15 pop", fifteenMinPop)
			// console.log("15 prop", fifteenMinProp)
			// console.log("accessMax", accessMax)
			// console.log("heatmap rendered")

			// // load the data only if it hasnt been loaded
			// const geojson = geojson2h3.h3SetToFeatureCollection(
			// 	Object.keys(hexagons),
			// 	hex => ({mobility: hexagons[hex].mobility, 
			// 				entertainment: hexagons[hex].entertainment,
			// 				food_choices: hexagons[hex].food_choices,
			// 				active_living: hexagons[hex].active_living,
			// 				community_space: hexagons[hex].community_space,
			// 				health: hexagons[hex].health,
			// 				mobility: hexagons[hex].mobility,
			// 				education: hexagons[hex].education,
			// 				accessibility: hexagons[hex].accessibility,
			// 				population: hexagons[hex].population})
			// );

			// // remove old layers and sources to optimize render
			// map.removeLayer(`h3-hexes-layer`)
			// map.removeSource(`h3-hexes`)
			
			// const sourceId = `${city}-h3-hexes`;
			// const layerId = `${city}-${sourceId}-layer`;
			addCityHeatmapLayer(map, cityGeojson)
			
			// map.setPaintProperty(layerId, 'fill-opacity', config.fillOpacity);
			})

		// 	resolve()
		
		// })

		// geojson = null
}

function addCityHeatmapLayer(map, cityGeojson) {

	const sourceId = `h3-hexes`;
			const layerId = `${sourceId}-layer`;
			let source = map.getSource(sourceId);
			
			// Add the source and layer if we haven't created them yet
			if (!source) {
				map.addSource(sourceId, {
					type: 'geojson',
					data: cityGeojson
				});
				map.addLayer({
					id: layerId,
					source: sourceId,
					className: "hexes",
					type: 'heatmap',
					interactive: false,
					// zoom: 9.5,
					// maxZoom: 12,
					minzoom: 9,
					// maxzoom: 15,
					paint: {
						// increase weight as diameter breast height increases
						'heatmap-weight': {
							'property': 'accessibility',
							'type': 'exponential',
							'stops': [
								[0, 0.1],
								[0.3, 0.1],
								[1, 1]
							]
						},
						// increase intensity as zoom level increases
						'heatmap-intensity': {
							'stops': [
								[9, 0.7],
								[11, 1],
								[15, 3],
								// [18, 3]
							]
						},
						// use sequential color palette to use exponentially as the weight increases
						'heatmap-color': [
							'interpolate',
							['linear'],
							['heatmap-density'],
							0, 'rgba(236,222,239,0)',
							// 0.005, config.colorScale[1],
							0.1, config.colorScale[1],
							0.2, config.colorScale[2],
							// 0.2, 'rgba(236,222,239,0)',
							0.3, config.colorScale[3],
							0.4, config.colorScale[4],
							0.5, config.colorScale[5],
							0.6, config.colorScale[6],
							0.7, config.colorScale[7],
							0.9, config.colorScale[8],
							1, config.colorScale[9]
							// ['exponential', 100],
							// ['heatmap-density'],
							// 0, config.colorScale[0],
							// 0.1, config.colorScale[1],
							// 0.2, config.colorScale[2],
							// // 0.2, 'rgba(236,222,239,0)',
							// 0.3, config.colorScale[3],
							// 0.4, config.colorScale[4],
							// 0.5, config.colorScale[5],
							// 0.6, config.colorScale[6],
							// 0.7, config.colorScale[7],
							// 0.9, config.colorScale[8],
							// 1, config.colorScale[9]


							// 0, 'rgba(236,222,239,0)',
							// 0.005, config.colorScale[1],
							// 0.1, config.colorScale[1],
							// // 0.2, config.colorScale[2],
							// // 0.2, 'rgba(236,222,239,0)',
							// 0.3, config.colorScale[2],
							// // 0.4, config.colorScale[4],
							// // 0.5, config.colorScale[5],
							// 0.6, config.colorScale[3],
							// 0.7, config.colorScale[7],
							// 0.9, config.colorScale[8],
							// // 0.95, config.colorScale[9],
							// 1, config.colorScale[9]
							// 0,
							// 'rgba(236,222,239,0)',
							// 0.2,
							// 'rgb(208,209,230)',
							// 0.4,
							// 'rgb(166,189,219)',
							// 0.6,
							// 'rgb(103,169,207)',
							// 0.8,
							// 'rgb(28,144,153)'
						],
						// increase radius as zoom increases
						'heatmap-radius': {
							'stops': [
								[9, 3*latFactor],
								[11, 8*latFactor],
								[13, 20*latFactor],
								[14, 40*latFactor],
								[15, 70*latFactor],
								// [18, 80]
							]
						},
						// increase radius as zoom increases
						'heatmap-opacity': {
							'stops': [
								[9, 0.85],
								[11, 0.7],
								[13, 0.7],
								[15, 0.5]
							]
						}
					}
				},
				"poi-label"
				// 'land'
				);
				source = map.getSource(sourceId);
			}

			// map.addLayer(
			// {
			// 'id': 'add-buildings',
			// 'source': 'composite',
			// 'source-layer': 'building',
			// 'type': 'fill',
			// 'paint' : {
			// 	'fill-color': 'blue',
			// 	'fill-opacity': 1
			// 	},
			// }, "poi-label")
			
			// Update the geojson data
			source.setData(cityGeojson);

			// map.moveLayer(layerId, 'add-buildings')

			// find ID of symbol layer
			// const layers = map.getStyle().layers;
			// console.log("layers", layers)
			// Find the index of the first symbol layer in the map style.
			// for (const layer of layers) {
			// 	if (layer.type === 'fill' && layer.id !== "land" && layer.id !== "land") {
			// 		map.moveLayer("land", 'airport-label');
			// 	break;
			// 	}
			// }
			// let firstSymbolId;
			// for (const layer of layers) {
			// 	if (layer.type === 'symbol') {
			// 		firstSymbolId = layer.id;
			// 	break;
			// 	}
			// }
			
			// Update the layer paint properties, using the current config values
			// map.setPaintProperty(layerId, 'fill-color', {
			// 	property: 'accessibility',
			// 	stops: [
			// 	[0.2, config.colorScale[0]],
			// 	[0.3, config.colorScale[1]],
			// 	[0.4, config.colorScale[2]],
			// 	[0.5, config.colorScale[3]],
			// 	[0.6, config.colorScale[4]],
			// 	[0.7, config.colorScale[5]],
			// 	[0.8, config.colorScale[6]]
			// 	]
			// });
			
			// tooltip
			// map.on('click', layerId, (e) => {
			map.on('mouseover', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				showTooltip(e)
			});
			
			map.on('mousemove', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				// selectAll(".mapboxgl-popup-content").remove()
				// selectAll(".mapboxgl-popup-tip").remove()
				showTooltip(e)
			});

			map.on('click', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				showTooltip(e)
			});
				
				// Change the cursor to a pointer when
				// the mouse is over the states layer.
			map.on('mouseenter', layerId, () => {
				map.getCanvas().style.cursor = 'pointer';
			});
			
			// Change the cursor back to a pointer
			// when it leaves the states layer.
			map.on('mouseleave', layerId, () => {
				map.getCanvas().style.cursor = '';
				selectAll(".mapboxgl-popup").remove()
				eCoords = null;
				// selectAll(".mapboxgl-popup-content").remove()
				// selectAll(".mapboxgl-popup-tip").remove()
				// selectAll(".mapboxgl-popup mapboxgl-popup-anchor-top").remove()
			});
}

function renderHeatmapH(map, city) {

	globeView = false;
	console.log("rendering heatmap")
	// return new Promise(function(resolve, reject) {
		// map["scrollZoom"].enable();
		// map["dragPan"].enable();

		let weightSum = entWeight+foodWeight+alWeight+mobWeight+comWeight+healthWeight+eduWeight

		loadAndPrepareData(city)
		.then(data=> data.map(d=> ({ ...d, nightlife: d.nightlife!==undefined?d.nightlife:null, 
										mobility: d.mobility!==undefined?d.mobility:null, 
										education: d.education!==undefined?d.education:null, 
										community_space: d.community_space!==undefined?d.community_space:null, 
										health_wellbeing: d.health_wellbeing!==undefined?d.health_wellbeing:null, 
										food_choices: d.food_choices!==undefined?d.food_choices:null, 
										active_living: d.active_living!==undefined?d.active_living:null })))
		.then(data=>data.map(d=> ({ ...d, accessibility: Math.log(((entWeight*d.nightlife)+
																	(foodWeight*d.food_choices)+
																	(alWeight*d.active_living)+
																	(mobWeight*d.mobility)+
																	(comWeight*d.community_space)+
																	(healthWeight*d.health_wellbeing)+
																	(eduWeight*d.education))/weightSum),
										accessibilityRawDist: +((entWeight*d.nightlife)+
																	(foodWeight*d.food_choices)+
																	(alWeight*d.active_living)+
																	(mobWeight*d.mobility)+
																	(comWeight*d.community_space)+
																	(healthWeight*d.health_wellbeing)+
																	(eduWeight*d.education))/weightSum,
										//   accessibilityRaw: distanceToNorm(((entWeight*d.nightlife)+
										// 							(foodWeight*d.food_choices)+
										// 							(alWeight*d.active_living)+
										// 							(mobWeight*d.mobility)+
										// 							(comWeight*d.community_space)+
										// 							(healthWeight*d.health_wellbeing)+
										// 							(eduWeight*d.education))/weightSum)
																})))
			
			// normalize accessibility
			// .then(data=>data.map(d=> ({...d, accessibility: 1-normScale(d.accessibility)})))
			.then(data=> {
					let normScale = scaleLinear().domain(extent(data.filter(d=>d.accessibility!== -Infinity), d=> +d.accessibility)).range([0, 1]);
					data = data.map(d=> ({...d, accessibility: 1-normScale(d.accessibility)
											}))
					// console.log("test",data)
				return data
			})
		
			.then(data=> {
						// final dataset will be stored here
						let hexagons = {}
						data.forEach(d => {
							const h3Index = geoToH3(d.lat, d.lng, h3Resolution);
							// Add school hex
							hexagons[h3Index] = {mobility:d.mobility, 
											entertainment:d.nightlife,
											food_choices:d.food_choices,
											active_living:d.active_living,
											community_space:d.community_space,
											health:d.health_wellbeing,
											mobility:d.mobility,
											education:d.education,
											accessibility: d.accessibility,
											accessibilityRawDist: d.accessibilityRawDist,
											population: d.POP_2015}
										
							}
						
							)
				// 		return layer
				// })
				// .then(hexagons=>{

				// load the data only if it hasnt been loaded
				const geojson = geojson2h3.h3SetToFeatureCollection(
					Object.keys(hexagons),
					hex => ({mobility: hexagons[hex].mobility, 
								entertainment: hexagons[hex].entertainment,
								food_choices: hexagons[hex].food_choices,
								active_living: hexagons[hex].active_living,
								community_space: hexagons[hex].community_space,
								health: hexagons[hex].health,
								mobility: hexagons[hex].mobility,
								education: hexagons[hex].education,
								accessibility: hexagons[hex].accessibility,
								accessibilityRawDist: hexagons[hex].accessibility,
								population: hexagons[hex].population
							})
				);
			
			// console.log("data", data)
			console.log("data full", data.length)
			// data = data.filter(d=>d.POP_2015>=1)
			// console.log("data filtered", data.length)

			// with data
			totalPop = countryData.filter(d=>d.ID_HDC_G0 === $selectedCity)[0].P15//sum(data, d=>d.POP_2015)
			fifteenMinPop = sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015)
			fifteenMinProp = (fifteenMinPop/totalPop)*100>100?100:(fifteenMinPop/totalPop)*100
			// with agg
			// totalPop = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].P15
			// fifteenMinPop = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].fifteenPopAccess
			// fifteenMinProp = countryData.filter(d=>d.ID_HDC_G0===selectedCity)[0].fifteenPropAccess

			// console.log("fifteenMinPopData", sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015))
			// console.log("fifteenMinPopAgg", fifteenMinPop)
			// console.log("fifteenMinPropData", (sum(data.filter(d=>d.accessibilityRawDist<=1250), d=>d.POP_2015)/totalPop)*100)
			// console.log("fifteenMinPropAgg", fifteenMinProp)
			// accessMean = mean(data, d=>d.accessibilityRawDist)
			// accessMax = max(data, d=>d.accessibilityRawDist)
			// filter data that is 5000 meters
			// console.log("datapoints before 5000 filter", data.length)
			// data = data.filter(d=>d.accessibilityRawDist<4000)
			// console.log("datapoints after 5000 filter", data.length)

			// const geojson = {
			// 	"type": "FeatureCollection",
			// 	"features": data.map(d=>{
			// 		return {
			// 			"type":"Feature",
			// 			"geometry":{
			// 				"type":"Point",
			// 				"coordinates":[
			// 					d.lng,
			// 					d.lat
			// 				]
			// 			},
			// 			"properties":{
			// 				mobility:d.mobility, 
			// 				entertainment:d.nightlife,
			// 				food_choices:d.food_choices,
			// 				active_living:d.active_living,
			// 				community_space:d.community_space,
			// 				health:d.health_wellbeing,
			// 				mobility:d.mobility,
			// 				education:d.education,
			// 				accessibility: d.accessibility,
			// 				accessibilityRawDist: d.accessibilityRawDist,
			// 				population: d.POP_2015
			// 			}
			// 		}
			// 	})
			// }

			// console.log("data", geojson)
			console.log("total pop", totalPop)
			console.log("15 pop", fifteenMinPop)
			console.log("15 prop", fifteenMinProp)
			console.log("accessMax", accessMax)
			// console.log("heatmap rendered")

			// // load the data only if it hasnt been loaded
			// const geojson = geojson2h3.h3SetToFeatureCollection(
			// 	Object.keys(hexagons),
			// 	hex => ({mobility: hexagons[hex].mobility, 
			// 				entertainment: hexagons[hex].entertainment,
			// 				food_choices: hexagons[hex].food_choices,
			// 				active_living: hexagons[hex].active_living,
			// 				community_space: hexagons[hex].community_space,
			// 				health: hexagons[hex].health,
			// 				mobility: hexagons[hex].mobility,
			// 				education: hexagons[hex].education,
			// 				accessibility: hexagons[hex].accessibility,
			// 				population: hexagons[hex].population})
			// );

			// // remove old layers and sources to optimize render
			// map.removeLayer(`h3-hexes-layer`)
			// map.removeSource(`h3-hexes`)
			
			// const sourceId = `${city}-h3-hexes`;
			// const layerId = `${city}-${sourceId}-layer`;
			const sourceId = `h3-hexes`;
			const layerId = `${sourceId}-layer`;
			let source = map.getSource(sourceId);
			
			// Add the source and layer if we haven't created them yet
			if (!source) {
				map.addSource(sourceId, {
					type: 'geojson',
					data: geojson
				});
				map.addLayer({
					id: layerId,
					source: sourceId,
					className: "hexes",
					type: 'fill',
					interactive: false,
					// zoom: 9.5,
					// maxZoom: 12,
					minzoom: 9,
					// maxzoom: 15,
					paint: {
					'fill-outline-color': 'transparent',
					// 'fill-outline-color': 'rgba(0,0,0,0)',
					// increase radius as zoom increases
					'fill-opacity': {
							'stops': [
								[9, 0.85],
								[11, 0.7],
								[13, 0.7],
								[15, 0.5]
							]
						}
					}
					
				},
				"poi-label"
				// 'land'
				);
				source = map.getSource(sourceId);
			}

			// Update the geojson data
			source.setData(geojson);
			
			// Update the layer paint properties, using the current config values
			map.setPaintProperty(layerId, 'fill-color', {
				property: 'accessibility',
				stops: [
				[0.1, config.colorScale[0]],
				[0.2, config.colorScale[1]],
				[0.3, config.colorScale[2]],
				[0.4, config.colorScale[3]],
				[0.5, config.colorScale[4]],
				[0.6, config.colorScale[5]],
				[0.7, config.colorScale[6]],
				[0.9, config.colorScale[7]],
				[1, config.colorScale[9]],
				]
			});

			// map.addLayer(
			// {
			// 'id': 'add-buildings',
			// 'source': 'composite',
			// 'source-layer': 'building',
			// 'type': 'fill',
			// 'paint' : {
			// 	'fill-color': 'blue',
			// 	'fill-opacity': 1
			// 	},
			// }, "poi-label")
			
			// Update the geojson data
			source.setData(geojson);

			// map.moveLayer(layerId, 'add-buildings')

			// find ID of symbol layer
			const layers = map.getStyle().layers;
			// console.log("layers", layers)
			// Find the index of the first symbol layer in the map style.
			// for (const layer of layers) {
			// 	if (layer.type === 'fill' && layer.id !== "land" && layer.id !== "land") {
			// 		map.moveLayer("land", 'airport-label');
			// 	break;
			// 	}
			// }
			// let firstSymbolId;
			// for (const layer of layers) {
			// 	if (layer.type === 'symbol') {
			// 		firstSymbolId = layer.id;
			// 	break;
			// 	}
			// }
			
			// Update the layer paint properties, using the current config values
			// map.setPaintProperty(layerId, 'fill-color', {
			// 	property: 'accessibility',
			// 	stops: [
			// 	[0.2, config.colorScale[0]],
			// 	[0.3, config.colorScale[1]],
			// 	[0.4, config.colorScale[2]],
			// 	[0.5, config.colorScale[3]],
			// 	[0.6, config.colorScale[4]],
			// 	[0.7, config.colorScale[5]],
			// 	[0.8, config.colorScale[6]]
			// 	]
			// });
			
			// tooltip
			// map.on('click', layerId, (e) => {
			map.on('mouseover', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				showTooltip(e)
			});
			
			map.on('mousemove', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				// selectAll(".mapboxgl-popup-content").remove()
				// selectAll(".mapboxgl-popup-tip").remove()
				showTooltip(e)
			});

			map.on('click', layerId, (e) => {
				selectAll(".mapboxgl-popup").remove()
				showTooltip(e)
			});
				
				// Change the cursor to a pointer when
				// the mouse is over the states layer.
			map.on('mouseenter', layerId, () => {
				map.getCanvas().style.cursor = 'pointer';
			});
			
			// Change the cursor back to a pointer
			// when it leaves the states layer.
			map.on('mouseleave', layerId, () => {
				map.getCanvas().style.cursor = '';
				selectAll(".mapboxgl-popup").remove()
				eCoords = null;
				// selectAll(".mapboxgl-popup-content").remove()
				// selectAll(".mapboxgl-popup-tip").remove()
				// selectAll(".mapboxgl-popup mapboxgl-popup-anchor-top").remove()
			});
			
			// map.setPaintProperty(layerId, 'fill-opacity', config.fillOpacity);
			})

		// 	resolve()
		
		// })

		// geojson = null
}

function walkingTime(meters, short=false, lowerBound=false) {
		const km = meters/1000
		const hours = km/5
		const minutes = km/5 * 60
		const seconds = minutes*60
		// return hours or seconds or minutes
		if (short === true) {
			if (minutes<1) {
			// return seconds.toFixed() + "sec"
			return "less than 1 min."
			} else if (minutes>60){
			return hours.toFixed() + "h"
			} else {
			return minutes.toFixed() + "min"
			}
		} else {
			if (lowerBound===false) {
				if (minutes<1) {
				return "less than 1 minute"
				// return seconds.toFixed() + " seconds"
				} else if (minutes>60){
				return hours.toFixed() + " hours"
				} else {
				return minutes.toFixed() + " minutes"
				}
			} else {
				if (minutes<1) {
				return 1 + " minute"
				} else if (minutes>60){
				return hours.toFixed() + " hour"
				} else {
				return minutes.toFixed() + " minutes"
				}
			}
		}

		// return `${hours}, ${minutes}, ${seconds}`
}

function showTooltipGlobe(event) {

		const cityData = event.features[0].properties
		// const cityID = cityData.ID_HDC_G0
		// console.log(cityID)
		const cityfifteenMinProp = (cityData.fifteenPropAccess).toFixed()>100?100:(cityData.fifteenPropAccess).toFixed()
		const accessValue = cityData.accessibility
		const accessNormValue = cityData.accessibilityNorm
		const color = accessScale(accessNormValue)
		// console.log(cityData)
		selectAll(".mapboxgl-popup").remove()

		new mapboxgl.Popup()
			.setLngLat(event.features[0].geometry.coordinates)
			.setHTML(`<span style="color: ${mainDrawColor}; text-align:left; font-weight:700">${cityData.UC_NM_CTR}</span><br>
				<span style="color: ${mainDrawColor}; text-align:left;">Average walking time to services:</span>
				<span style="color:${color};font-weight:700"> ${walkingTime(accessValue, true, false)}</span><br>
				<span style="color: ${mainDrawColor}; text-align:left;">% of pop. within 15 min of services:</span>
				<span style="color:${color};font-weight:700"> ${cityfifteenMinProp}%</span><br>`)
			.addTo(map);
		
			// <span style="color: ${mainDrawColor}; opacity:0.7" onclick=${flyToNewCity(map, cityID)}>👆 click me to explore</span>

		selectAll(".mapboxgl-popup-content")
		// .style("background-color", multiValue==="dark"?"black":"rgb(248, 248, 248)")
		.style("background-color", darkMode===true?mainBgColorControls:"rgb(248, 248, 248)")
		// .style("fill", multiValue==="dark"?"#ccc":"black")
		.style("fill", darkMode===false?"#ccc":mainBgColorControls)
		.style("border", `${borderWidthTooltip}px solid ${mainBorderColor}`)
		.style("box-shadow", `${darkMode===true?"none":boxShadow}`)

		selectAll(".mapboxgl-popup-content")
		.append("button")
		.style("color",mainDrawColor)
		.style("background-color", mainBgColorControls)
		.style("margin-bottom", 0)
		.style("margin-top", "5px")
		.attr("class", "tooltipButton")
		.style("font-size", "10px")
        .style("text-transform", "uppercase")
		.style("cursor", "pointer")
		.style("border", `${borderWidthButtons}px solid ${mainBorderColor}`)
		.text("👆 click me to explore")
		.on("click", (d,e)=>{
			selectedCity.set(cityData.ID_HDC_G0)
			selectedCityName.set(cityData.UC_NM_CTR)
			selectedCountry.set(cityData.CTR_MN_NM)
			flyToNewCity(map, $selectedCity)
			selectAll(".mapboxgl-popup").remove()
		})
}

function showTooltip(e) {

  eCoords = e.point;
  tooltipFeatures = e.features[0];
	// 	// console.log(eCoords)
	
	//   // if (e.features[0].properties.accessibility)
	//   // console.log(e)
	//   // new mapboxgl.Popup({className: "accessTooltip"})
	//   const aLevel = e.features[0].properties.accessibility<=0.1?"very low":
	//               (e.features[0].properties.accessibility>0.1)&&(e.features[0].properties.accessibility<=0.4)?"low":
	//               (e.features[0].properties.accessibility>0.4)&&(e.features[0].properties.accessibility<=0.6)?"average":
	//               (e.features[0].properties.accessibility>0.6)&&(e.features[0].properties.accessibility<=0.8)?"high":
	//               e.features[0].properties.accessibility>0.8?"very high":""
		
	//   const color = accessScale(e.features[0].properties.accessibility)

	//   new mapboxgl.Popup()
	//       .setLngLat(e.lngLat)
	//       .setHTML(`<span style="color: ${mainDrawColor}; text-align:left"> Accessibility to urban services for the <b>${e.features[0].properties.population.toFixed()}</b> residents of this area is</span> <b><span style="text-transform:uppercase;color:${color}">${aLevel}</span></b><br>
	//               <table>
	//                   <tr>
	//                   <th style="text-transform: uppercase; color: ${mainDrawColor}; border: none;">Amenity type</th>
	//                   <th class="tableSep" style="text-transform: uppercase; color: ${mainDrawColor}; border: none;">Average walking time</th>
	//                   </tr>
	//                   <tr>
	//                   <td style="color: ${mainDrawColor};border-bottom:1px solid ${mainBgColorControls};border-bottom-width: 0px; z-index:0;text-align:left">Public transit stations</td>
	//                   <td class="tableSep" style="border-left:1px solid ${mainDrawColor};text-align: center;"><b><span style="color:${color}">${walkingTime(e.features[0].properties.mobility)}</b></td>
	//                   </tr>
	//                   <tr>
	//                   <td style="color: ${mainDrawColor};border-bottom:1px solid ${mainBgColorControls};border-bottom-width: 0px z-index:0;text-align:left">Education facilities</td>
	//                   <td class="tableSep" style="border-left:1px solid ${mainDrawColor};text-align: center;"><b><span style="color:${color}">${walkingTime(e.features[0].properties.education)}</b></td>
	//                   </tr>
	//                   <tr>
	//                   <td style="color: ${mainDrawColor};border-bottom:1px solid ${mainBgColorControls};border-bottom-width: 0px z-index:0;text-align:left">Parks, stadiums, and gyms</td>
	//                   <td class="tableSep" style="border-left:1px solid ${mainDrawColor};text-align: center;"><b><span style="color:${color}">${walkingTime(e.features[0].properties.active_living)}</b></td>
	//                   </tr>
	//                   <tr>
	//                   <td style="color: ${mainDrawColor};border-bottom:1px solid ${mainBgColorControls};border-bottom-width: 0px z-index:0;text-align:left">Cinemas, nightclubs and theatres</td>
	//                   <td class="tableSep" style="border-left:1px solid ${mainDrawColor};text-align: center;"><b><span style="color:${color}">${walkingTime(e.features[0].properties.entertainment)}</b></td>
	//                   </tr>
	//                   <tr>
	//                   <td style="color: ${mainDrawColor};border-bottom:1px solid ${mainBgColorControls};border-bottom-width: 0px z-index:0;text-align:left">Restaurants, food trucks and supermarkets</td>
	//                   <td class="tableSep" style="border-left:1px solid ${mainDrawColor};text-align: center;"><b><span style="color:${color}">${walkingTime(e.features[0].properties.food_choices)}</b></td>
	//                   </tr>
	//                   <tr>
	//                   <td style="color: ${mainDrawColor};border-bottom:1px solid ${mainBgColorControls};border-bottom-width: 0px z-index:0;text-align:left">Pharmacies, clinics and hospitals</td>
	//                   <td class="tableSep" style="border-left:1px solid ${mainDrawColor};text-align: center;"><b><span style="color:${color}">${walkingTime(e.features[0].properties.health)}</b></td>
	//                   </tr>
	//                   <tr>
	//                   <td style="color: ${mainDrawColor};border-bottom:1px solid ${mainBgColorControls};border-bottom-width: 0px z-index:0;text-align:left">Libraries and community centres</td>
	//                   <td class="tableSep" style="border-left:1px solid ${mainDrawColor};text-align: center;"><b><span style="color:${color}">${walkingTime(e.features[0].properties.community_space)}</b></td>
	//                   </tr>
	//               </table>`)
	//       // .setHTML(`Accessibility to urban services in this area is <b><span style="text-transform:uppercase;color:${color}">${aLevel}</span></b><br><br>
	//       //           Average walking time to <br>
	//       //           Public transit stations: <b><span style="color:${color}">${walkingTime(e.features[0].properties.mobility)}</b> <br>
	//       //           Education facilities: <b><span style="color:${color}">${walkingTime(e.features[0].properties.education)}</b> <br>
	//       //           Parks, stadiums, and gyms: <b><span style="color:${color}">${walkingTime(e.features[0].properties.active_living)}</b> <br>
	//       //           Cinemas, nightclubs and theatres: <b><span style="color:${color}">${walkingTime(e.features[0].properties.entertainment)}</b> <br>
	//       //           Restaurants, food trucks and supermarkets: <b><span style="color:${color}">${walkingTime(e.features[0].properties.food_choices)}</b> <br>
	//       //           Pharmacies, clinics and hospitals: <b><span style="color:${color}">${walkingTime(e.features[0].properties.health)}</b> <br>
	//       //           Libraries and community centres: <b><span style="color:${color}">${walkingTime(e.features[0].properties.community_space)}</b> <br>`)
	//       // .setHTML(`Accessibility: ${(e.features[0].properties.accessibility).toFixed(2)}`)
	//       .addTo(map);
		
	//       selectAll(".mapboxgl-popup-content")
	//           // .style("background-color", multiValue==="dark"?"black":"rgb(248, 248, 248)")
	//           .style("background-color", darkMode===true?mainBgColorControls:"rgb(248, 248, 248)")
	//           // .style("fill", multiValue==="dark"?"#ccc":"black")
	//           .style("fill", darkMode===false?"#ccc":mainBgColorControls)
	//           .style("border", `2px solid ${mainBorderColor}`)

	//       selectAll(".mapboxgl-popup")
	//           .style("max-width", "340px")

	//           // .style("max-width", innerWidth>640?"340px":"none")
			
	//       // selectAll(".mapboxgl-popup-tip")
	//       //     .style("fill", "none")
	//   // .attr("rx", 50)
}

function flyToNewCity(map, selection) {

		// selectedCity = selection

		if (map.getSource('h3-hexes')) {
			map.removeLayer(`h3-hexes-layer`)
			map.removeSource(`h3-hexes`)
			sourceLoaded=false;
		} 
		// sourceLoaded=false;
		// map.removeLayer(`h3-hexes-layer`)
		// console.clearStorage()
		// localStorage.clear()
		// renderHexes(map, selection)
		// console.log("selection", selection)
		// reset proportion
		
		selectionData = aggData.filter(d=>d.ID_HDC_G0===selection)
		// console.log("selectionData", selectionData)
		const coords = [selectionData[0].lng, selectionData[0].lat]
		currentLat = coords[1]
		// console.log(coords)
      
		// fly to new city
		// OLD METHOD
		// renderHeatmap(map, selection)
		// const center = fetch(`https://api.tiles.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(selection)}.json?access_token=${mapboxgl.accessToken}`)
		// 			.then(response => response.json())
		// 			.then(geocoding => geocoding.features[0].center)
		// 			.then(center => map.flyTo({
		// 				center,
		// 				essential: true,
		// 				zoom:9.5,
		// 				// maxZoom: 12,
		// 				// minZoom: 9,
		// 				// speed: 0.5, // make the flying slow
		// 				// curve: 1, // change the speed at which it zooms out
		// 			}))
		// NEW METHOD
		map.flyTo({
						center: coords,
						essential: true,
						zoom:11,
						// maxZoom: 12,
						// minZoom: 9,
						// speed: 0.5, // make the flying slow
						// curve: 1, // change the speed at which it zooms out
					})
					
		renderHeatmap(map, selection)
		// .then(function() {
		// 	// console.log("heatmap rendered")
		// 	console.log(map.getLayer('h3-hexes-layer'))
		// })
		
		// remove old layers and sources to optimize render
		// map.removeLayer(`h3-hexes-layer`)
		// map.removeSource(`h3-hexes`)
		mapboxgl.clearStorage()
}

function resetSliders() {
		entWeight=1;
		foodWeight=1;
		alWeight=1;
		mobWeight=1;
		comWeight=1;
		healthWeight=1;
		eduWeight=1;

		entCheck=true;
		foodCheck=true;
		alCheck=true;
		mobCheck=true;
		comCheck=true;
		healthCheck=true;
		eduCheck=true;
}

function sourceCallback() {
    // assuming 'map' is defined globally, or you can use 'this'
    if (map.getSource('h3-hexes') && map.isSourceLoaded('h3-hexes')) {
		setTimeout(() => {
			sourceLoaded=true;
			}, "2000"
		)
    } 
}

function getRscale(data, radius, innerWidth) {
        let rScale = 
		scaleSqrt()
            .domain(extent(data, d=>d.P15))
            .range(innerWidth>1000?[radius/2, radius*5]:innerWidth>640?[radius/2.5, radius*4.5]:[radius/3, radius*3])

        return rScale
}

function themeSwitch(map, aggData, selectedCity) {
	
	// const target = event.target

	// const value = target.getAttribute('value')

	// console.log(darkMode)

	// checked = state === 'true' ? false : true

	// value = checked === true ? 'on' : 'off'

	// value === "light" ? map.setStyle('mapbox://styles/mapbox/light-v10?optimize=true'): 
	//                     map.setStyle('mapbox://styles/lnicoletti/ckvzlna3h2vb215mv5hfzfbck/draft?optimize=true')

	loaded = false

	// change map tile theme
	darkMode === true? map.setStyle(mapboxglDarkStyle): map.setStyle(mapboxglLightStyle)

	// darkMode === true ? document.body.style.backgroundColor = "black":
	// 					document.body.style.backgroundColor = "rgb(248, 248, 248)"
	
	// darkMode === true ? document.getElementById("mainContent").style.backgroundColor = "#040404":
	// 					document.getElementById("mainContent").style.backgroundColor = "rgb(248, 248, 248)"

	if (zoom<=9) {
		// map.removeLayer(`poi-agg-layer`)
		// map.removeLayer(`cities-point`)
		// map.removeSource(`poi-agg`)
		map.on('style.load', function() {
			renderGlobeMap(map, aggData)
			loaded=true
		})
	} else if (zoom>=9 && selectedCity !== null) {
		map.removeLayer(`h3-hexes-layer`)
		map.removeSource(`h3-hexes`)
		map.on('style.load', function() {
			renderGlobeMap(map, aggData)
			// renderHeatmap(map, selectedCity)
			addCityHeatmapLayer(map, cityGeojson)
			loaded=true
		})
	}
}




// $: console.log('source loaded:', sourceLoaded);
// $: console.log("heatmap reload condition", (zoom>=9&&selectedCity!==null))
// $: console.log("globemap reload condition", (zoom<=5))


</script>

<!-- MAP CONTAINER -->
<div id="access" style='height:100vh'></div>
<Instructions {borderWidthBoxes} {borderWidthButtons} {boxShadow} {innerHeight} {innerWidth} {mainBgColor} {mainDrawColor} {mainTitleColor} {mainBgColorControls} {mainBorderColor} {mainSvgColor} {mainSpecialColor} {mainSpecialColorActive} {borderWidthSearch} {darkMode} {headerItemsMargins} {distPlotWidthRatio} {borderWidthTooltip} {map} {aggData} {metroData} {getRscale} {radius} {accessScale} {walkingTime} {mapboxgl} {pageID} {zoom} {options} {groupBy}/>
<!-- LOADING SPINNER -->
{#if sourceLoaded===false&&globeView===false}
	<div style="transform:translate({innerWidth/2}px, {innerHeight/2}px);width:60px;height:60px;position:absolute;">
		<Circle2 size="60" colorOuter={config.colorScale[8]} colorCenter={config.colorScale[4]} colorInner={config.colorScale[6]} unit="px"></Circle2>
		<!-- <Stretch size="60" color={mainSpecialColor} unit="px"></Stretch> -->
	</div>
	<div style="transform:translate({innerWidth/2}px, {innerHeight/2+80}px);width:200px;position:absolute;">
		{#if cityGeojson!==null&&cityDataLen>50000&&cityDataLen<100000}
				<span style="color:{mainDrawColor}">Retrieving city data...</span>
		{:else if cityGeojson!==null&&cityDataLen>100000}
				<span style="color:{mainDrawColor}">Wow, this city is huge! Please wait while we retrieve its data...</span>
		{/if}
	</div>
{/if}
<!-- DARK MODE SWITCH -->
<div style="z-index:10;text-align:center;transform:translate({innerWidth>400?headerItemsMargins:6}px,12px);position:absolute;">
	<!-- svelte-ignore a11y-mouse-events-have-key-events -->
	<span 
	class="material-symbols-outlined" 
	style="color:{darkMode===false?mainSpecialColor:mainDrawColor};cursor:{darkMode===true?"pointer":"default"};opacity:{darkMode===false?1:0.8};font-variation-settings:{darkMode===true?"'FILL' 0":"'FILL' 1"};"
	on:click={()=> {
		if (darkMode===true) {
			darkMode = false
			themeSwitchHovered=false
			themeSwitch(map, aggData, $selectedCity)
		}
		// renderGlobeMap(map, aggData)
	}}
	on:mouseover={()=>{darkMode===false?themeSwitchHovered=false:themeSwitchHovered=true}}
	on:mouseleave={()=>{themeSwitchHovered=false}}>
		light_mode
	</span><!-- svelte-ignore a11y-mouse-events-have-key-events 
 --><span 
	class="material-symbols-outlined"
	style="color:{darkMode===true?mainSpecialColor:mainDrawColor};cursor:{darkMode===false?"pointer":"default"};opacity:{darkMode===true?1:0.8};font-variation-settings:{darkMode===true?"'FILL' 1":"'FILL' 0"}"
	on:click={()=>{
		if (darkMode===false) {
			darkMode = true
			themeSwitchHovered=false
			themeSwitch(map, aggData, $selectedCity)
		}
		// renderGlobeMap(map, aggData)
	}}
	on:mouseover={()=>{darkMode===true?themeSwitchHovered=false:themeSwitchHovered=true}}
	on:mouseleave={()=>{themeSwitchHovered=false}}>
		dark_mode
	</span>
	<!-- single switch -->
	<!-- <span 
	class="material-symbols-outlined"
	style="color:{mainDrawColor};cursor:pointer;font-variation-settings:'FILL' 1"
	on:click={()=>{
		if (darkMode===false) {
			darkMode = true
			themeSwitchHovered=false
			themeSwitch(map, aggData, selectedCity)

		} else if (darkMode===true) {
			darkMode = false
			themeSwitchHovered=false
			themeSwitch(map, aggData, selectedCity)
		}
		// renderGlobeMap(map, aggData)
	}}
	on:mouseover={()=>{themeSwitchHovered=true}}
	on:mouseleave={()=>{themeSwitchHovered=false}}>
		{darkMode===false?"dark_mode":"light_mode"}
	</span> -->
	<!-- <ThemeSwitch {darkMode} {mainDrawColor}/> -->
    <!-- on:change={()=>renderHeatmap(map, selectedCity) -->
    <!-- <SwitchSimple bind:checked={darkMode} {map}></SwitchSimple> -->
</div>
<!-- SWITCH TOOLTIP -->
{#if themeSwitchHovered&&innerWidth>400}
	<div class="switchTooltip" style="z-index:10;text-align:center;transform:translate({headerItemsMargins+60}px,12px);position:absolute;background-color:{mainBgColorControls};border:{borderWidthBoxes}px solid {mainBorderColor}; box-shadow: {darkMode===true?"none":boxShadow}">
		<span style="color:{mainDrawColor}">switch to {darkMode===true?"light":"dark"} mode</span>
	</div>
{/if}
<!-- TOOLTIP -->
{#if eCoords!==null&&tooltipActive===true}
	<MapTooltip {eCoords} {tooltipFeatures} {mainSvgColor} {mainDrawColor} {borderWidthTooltip} {boxShadow} {mainSpecialColor} {accessScale} {mainBorderColor} {mainBgColorControls} {selectionData} {darkMode} {innerWidth} {innerHeight} visibility = {"visible"}/>
{/if}
<!-- INFO POINT -->
<!-- <div id="infoPoint" 
     style="transform:translate({innerWidth-365}px, {45}px);
            color: {mainDrawColor};" on:click={()=> infoPopup = !infoPopup}>
    <span class="appTitle" style="color:{mainTitleColor};"><span style="text-transform: uppercase;">Urban<span style="color:{mainSpecialColor};">Access</span>Map</span> &#9432</span>
</div> -->
<!-- transform:translate({innerWidth>400?innerWidth-(headerItemsMargins+275.46):innerWidth-(6+275.46)}px, {10}px); -->
<!-- on:click={()=> infoPopup = !infoPopup} -->
<!-- transform:translate({innerWidth>400?innerWidth-(headerItemsMargins+275.46):innerWidth-(6+275.46)}px, {10}px) -->
<!-- {#if infoPopup===true} -->
<InfoPopup {borderWidthBoxes} {borderWidthButtons} {boxShadow} {innerHeight} {innerWidth} {mainBgColor} {mainDrawColor} {mainTitleColor} {mainBgColorControls} {mainBorderColor} {mainSpecialColor} {darkMode} {headerItemsMargins} {distPlotWidthRatio}/>
<!-- {/if} -->
{#if $infoPopup===false}
	<!-- WORLD DISTPLOT -->
	{#if $showGlobalTick===true}
	<div style="text-align:center;z-index:10;position:relative;transform:translate(0px, {38}px)">
		<DistPlot data = {metroData} {mainDrawColor} {mainSvgColor} {mainSpecialColor} {boxShadow} {mainBorderColor} {borderWidthTooltip} {mainBgColorControls} {innerWidth} country={"World"} highlightCities={exampleCities} fifteenMinProp={90} width={innerWidth*distPlotWidthRatio} axisLabel = {true} {map} {mapboxgl} {accessScale} {darkMode} {walkingTime} {rScale} {flyToNewCity}/>
	</div>
	{/if}
	<!-- CITIES DROPDOWN MENU -->
    <!-- <div style="z-index:10; transform:translate({innerWidth-262}px, {72}px); position:absolute;display:flex">  -->
	<div style="z-index:10; transform:translate({innerWidth>400?innerWidth-(headerItemsMargins+230):innerWidth-(15+230)}px, {$showGlobalTick?23:35}px); position:absolute;display:flex;cursor:pointer"> 
        <div 
        class="citiesSelect"
        style="--background: {mainBgColorControls}; 
               --placeholderColor:{mainDrawColor};
               --itemColor:{mainDrawColor}; 
               --border: {borderWidthSearch}px solid {mainBorderColor};
               --borderFocusColor:{mainSpecialColor};
               --listBackground:{mainBgColorControls};
               --inputFontSize: 14px;
               --inputColor:{mainDrawColor};
               --groupTitleFontSize: 14px;
               --groupTitleColor: {mainDrawColor};
               --groupTitleFontWeight: {700}px;
               --itemHoverBG: {mainSpecialColor};
			   --itemHoverColor: {mainBgColor};
               --itemIsActiveBG: {mainSpecialColorActive};
               cursor:pointer;
			   box-shadow: {darkMode===true?"none":boxShadow}
               "
        >
            <Select 
			inputStyles="cursor: pointer;"
            items={options} 
            {groupBy} 
            placeholder={darkMode===true?"🌆 search for a city...":"🏙️ search for a city..."}
            on:select={(event) => {
                selectedCity.set(event.detail.value)
                selectedCityName.set(event.detail.label)
				selectedCountry.set(event.detail.country)
                // console.log(event.detail)
                // console.log(selectedCity,":",selectedCityName.text)
                    flyToNewCity(map, $selectedCity)
                    }
                }>
            </Select>
        </div>
    </div>
{/if}
<!-- LEGENDS -->
<div style="z-index:10; 
			transform:translate({innerWidth/2-105}px, {innerWidth<940 && $showGlobalTick===true?innerHeight*heatLegendOffset:
													   innerWidth<940 && $showGlobalTick===false?innerHeight*heatLegendOffset+84:
													   innerWidth>940 && $showGlobalTick===false?innerHeight*heatLegendOffset+84:innerHeight*heatLegendOffset}px); 
			position:absolute"> 
<!-- <div style="z-index:10; transform:translate({innerWidth-262}px, {120}px); position:absolute">  -->
<!--  & innerWidth<640 & deets===false -->
	{#if showCircleLegend===true}
		<div style="text-align:center;transform:translate(0px, {-5}px)">
			<CircleLegend {mainDrawColor} {mainSpecialColor} {darkMode} {innerWidth} {rScale}/>
		</div>
	{/if}
	{#if innerWidth>640 && accessMax!==null}
		{#if darkMode===true}
			{#if $infoPopup===false}
				<UnivariateLegend colorVar={"access"} numTicks={6} darkMode={true} {mainDrawColor} {mainBgColor} {accessMax}/>
			{/if}
		{:else}
			{#if $infoPopup===false}
				<UnivariateLegend colorVar={"access"} numTicks={6} darkMode={false} {mainDrawColor} {mainBgColor} {accessMax}/>
			{/if}
		{/if}
	{:else if innerWidth<640 && accessMax!==null}
		{#if darkMode===true}
			{#if $infoPopup===false & innerWidth<640 & deets===false}
				<UnivariateLegend colorVar={"access"} numTicks={6} darkMode={true} {mainDrawColor} {mainBgColor} {accessMax}/>
			{/if}
		{:else}
			{#if $infoPopup===false & innerWidth<640 & deets===false}
				<UnivariateLegend colorVar={"access"} numTicks={6} darkMode={false} {mainDrawColor} {mainBgColor} {accessMax}/>
			{/if}
		{/if}
	{/if}
</div>
<!-- ENABLE FILTERS ON SMARTPHONE -->
{#if innerWidth<640 && showConsole===false && $infoPopup===false && $selectedCityName!==null && zoom>=9}
<button 
    id="smartphoneFilterButton" 
    type="button" 
    style="background-color: {mainBgColorControls};
    color: {mainDrawColor};
    border: {borderWidthButtons}px solid {mainBorderColor};
	box-shadow: {darkMode===true?"none":boxShadow};
    transform:translate(0px, {innerHeight/2}px);
	border-radius:3px;"
    on:click={() => {
        showConsole=!showConsole
    }}><span>{showConsole===false?"show filters":"hide filters"}</span>
</button>
<!-- 		transform:rotate(90deg) translate(100px, 250px)"-->
{/if}
<!-- CONSOLE WITH FILTERS -->
{#if showConsole===true && $selectedCityName!==null && zoom>=9}
	<!-- width: {innerWidth<600?"400px":innerWidth<450?"300px":"550px"}; -->
    <div id='console' 
        style="transform:{innerWidth<940?`translate(${innerWidth>400?headerItemsMargins:0}px, 90px)`:`translate(${innerWidth>400?headerItemsMargins:0}px, 30px)`};
				width: 300px;
				font-size: {innerWidth<400? "13px":"14.3px"};
				margin: {innerWidth<400? "5px":"10px"};
                background-color: {mainBgColorControls};
                color: {mainDrawColor};
                visibility:{$infoPopup===false?"visible":"hidden"};
                border: {borderWidthControlsBox}px solid {mainBorderColor};
				border-radius:3px;
				box-shadow: {darkMode===true?"none":boxShadow}">
                <!-- border: {darkMode===true?"none":"2px solid " + mainDrawColor}"> -->
        {#if innerWidth<640}
            <button class="closeButton" 
                    style="background-color: {mainBgColorControls};
                    color: {mainDrawColor};
                    visibility:{$infoPopup===false?"visible":"hidden"};
                    transform:translate(295px, -7px);
                    border: 0px solid {mainBorderColor}" on:click={()=>{
                        showConsole=false
                        deets=false
                        }}>X
            </button>
        {/if}
        <!-- INFO STATS ON SELECTED CITY -->
            <!-- OLD -->
        <p>In <span style="color:{mainSpecialColor};"><b>{$selectedCityName}</b></span>, <span style="color:{mainSpecialColor};"><b>{(fifteenMinPop/1000)<1000?(fifteenMinPop/1000).toFixed()+"K":(fifteenMinPop/1000000).toFixed(1)+"M"}</b></span> residents, or <span style="color:{mainSpecialColor};"><b>{fifteenMinProp.toFixed()}%</b></span> of the urban population, has access to <span style="color:{mainSpecialColor};"><b>{weightSum<7?"these ":""}</b></span>services within a 15 minute walk.</p>
		<!-- <Beeswarm {aggData} {mainDrawColor} {mainSpecialColor} {mainBorderColor} {mainBgColorControls} {innerWidth} country={selectedCountry} selectedCity={selectedCityName}/> -->
		<DistPlot data = {countryData} {mainDrawColor} {mainSvgColor} {mainSpecialColor} {boxShadow} {borderWidthTooltip} {mainBorderColor} {mainBgColorControls} {innerWidth} country={$selectedCountry} {darkMode} highlightCities={[$selectedCityName]} {fifteenMinProp} width={300} axisLabel = {false} {rScale}/>
            <!-- NEW -->
        <!-- <p>In <span style="color:{mainSpecialColor};"><b>{selectedCityName.text}</b></span>, <span style="color:{mainSpecialColor};"><b>{(fifteenMinPop/1000)<1000?(fifteenMinPop/1000).toFixed()+"K":(fifteenMinPop/1000000).toFixed(1)+"M"}</b></span> residents, or <span style="color:{mainSpecialColor};"><b>{fifteenMinProp.toFixed()}%</b></span> of the urban population, has access to <span style="color:{mainSpecialColor};"><b>{weightSum<7?"these ":""}</b></span>services within a 15 minute walk.</p> -->
        
        <!-- FILTER DOUBLE SLIDER -->
        <!-- <p style="margin-bottom:0px;margin-top:8px">Filter for areas with services available within:</p>
        <DoubleRangeSlider {map} {normToDistance} bind:start bind:end/> -->
		<FilterMapInput {map} {mainBgColorControls} {boxShadow} {darkMode} {mainDrawColor} {borderWidthButtons} {mainBorderColor} {latFactor} {config} {mainSpecialColor}/>
        <!-- <div class="labels"> -->
            <!-- <div class="label">{nice(start)}</div>
            <div class="label">{nice(end)}</div> -->
            <!-- <div class="label">{walkingTime(normToDistance(start), false, true)} walk</div>
            <div class="label">{walkingTime(normToDistance(end), false, true)} walk</div>
        </div>
        <br>
        <br> -->
        <!-- WEIGHT SLIDERS -->
        <details id="detailsBox" bind:open={deets}>
            <summary>How should services be weighted?</summary>
        <!-- <p>How should services be weighted?</p> -->
            <div class="sliderFlex" style="display:flex">
                <div class="weightSlider" style="font-size: {innerWidth<400? "11px":"13.3px"};">
                    <div style="display:flex;">
                        <input type=checkbox class={darkMode===true?"darkCheckbox":"lightCheckbox"} style="margin-bottom:0px;margin-top:auto;margin-right:3px" 
                        bind:checked={mobCheck} 
                        on:change={() => {
                            mobWeight=mobCheck===true?1:0
                            // renderHeatmap(map, selectedCity)
                        }}>
						<div style="display:flex; align-items: flex-end;">
                        	<p class="sliderLabel" style="margin-bottom:0px;">Public transit stations</p> 
							<img alt="alt" src={darkMode===true?"images/mobility_dark.png":"images/mobility_light.png"} width="20" height="20"/>
						</div>
                        <!-- ;margin-top:0px -->
                    </div>
                    <input type=range class={darkMode===true?"darkSlider":"lightSlider"} min=0 max=1 step=any bind:value={mobWeight} on:change={() => {
                        // renderHeatmap(map, selectedCity)
                    }}>
                </div>
                <div class="weightSlider" style="font-size: {innerWidth<400? "11px":"13.3px"};">
                    <div style="display:flex">
                        <input type=checkbox class={darkMode===true?"darkCheckbox":"lightCheckbox"} style="margin-bottom:0px;margin-top:auto;margin-right:3px" 
                        bind:checked={entCheck} 
                        on:change={() => {
                            entWeight=entCheck===true?1:0
                            // renderHeatmap(map, selectedCity)
                        }}>
						<div style="display:flex; align-items: flex-end;">
                        	<p class="sliderLabel" style="margin-bottom:0px;">Cinemas, nightclubs, and theatres</p>
							<img alt="alt" src={darkMode===true?"images/nightlife_dark.png":"images/nightlife_light.png"} width="20" height="20"/>
						</div>
                    </div>
                    <input type=range class={darkMode===true?"darkSlider":"lightSlider"} min=0 max=1 step=any bind:value={entWeight} on:change={() => {
                        // renderHeatmap(map, selectedCity)
                    }}>
                </div>
            </div>
            <div class="sliderFlex" style="display:flex">
                <div class="weightSlider" style="font-size: {innerWidth<400? "11px":"13.3px"};">
                    <div style="display:flex">
                        <input type=checkbox class={darkMode===true?"darkCheckbox":"lightCheckbox"} style="margin-bottom:0px;margin-top:auto;margin-right:3px" 
                        bind:checked={alCheck} 
                        on:change={() => {
                            alWeight=alCheck===true?1:0
                            // renderHeatmap(map, selectedCity)
                        }}>
						<div style="display:flex; align-items: flex-end;">
                        	<p class="sliderLabel" style="margin-bottom:0px;margin-top:2px">Parks, stadiums and gyms</p>
							<img alt="alt" src={darkMode===true?"images/active_living_dark.png":"images/active_living_light.png"} width="20" height="20"/>
						</div>
                    </div>
                    <input type=range class={darkMode===true?"darkSlider":"lightSlider"} min=0 max=1 step=any bind:value={alWeight} on:change={() => {
                        // renderHeatmap(map, selectedCity)
                    }}>
                </div>
                <div class="weightSlider" style="font-size: {innerWidth<400? "11px":"13.3px"};">
                    <div style="display:flex">
                        <input type=checkbox class={darkMode===true?"darkCheckbox":"lightCheckbox"} style="margin-bottom:0px;margin-top:auto;margin-right:3px" 
                        bind:checked={healthCheck} 
                        on:change={() => {
                            healthWeight=healthCheck===true?1:0
                            // renderHeatmap(map, selectedCity)
                        }}>
						<div style="display:flex; align-items: flex-end;">
                    		<p class="sliderLabel" style="margin-bottom:0px;margin-top:2px">Pharmacies, clinics, and hospitals</p>
							<img alt="alt" src={darkMode===true?"images/health_wellbeing_dark.png":"images/health_wellbeing_light.png"} width="20" height="20"/>
						</div>
                    </div>
                    <input type=range class={darkMode===true?"darkSlider":"lightSlider"} min=0 max=1 step=any bind:value={healthWeight} on:change={() => {
                        // renderHeatmap(map, selectedCity)
                    }}>
                </div>
            </div>
            <div class="sliderFlex" style="display:flex">
                <div class="weightSlider" style="font-size: {innerWidth<400? "11px":"13.3px"};">
                    <div style="display:flex">
                        <input type=checkbox class={darkMode===true?"darkCheckbox":"lightCheckbox"} style="margin-bottom:0px;margin-top:auto;margin-right:3px" 
                        bind:checked={comCheck} 
                        on:change={() => {
                            comWeight=comCheck===true?1:0
                            // renderHeatmap(map, selectedCity)
                        }}>
						<div style="display:flex; align-items: flex-end;">
                        	<p class="sliderLabel" style="margin-bottom:0px;margin-top:2px">Libraries and community centers</p>
							<img alt="alt" src={darkMode===true?"images/community_space_dark.png":"images/community_space_light.png"} width="20" height="20"/>
						</div>
                    </div>
                    <input type=range class={darkMode===true?"darkSlider":"lightSlider"} min=0 max=1 step=any bind:value={comWeight} on:change={() => {
                        // renderHeatmap(map, selectedCity)
                    }}>
                </div>
                <div class="weightSlider" style="font-size: {innerWidth<400? "11px":"13.3px"};">
                    <div style="display:flex">
                        <input type=checkbox class={darkMode===true?"darkCheckbox":"lightCheckbox"} style="margin-bottom:0px;margin-top:auto;margin-right:3px" 
                        bind:checked={eduCheck} 
                        on:change={() => {
                            eduWeight=eduCheck===true?1:0
                            // renderHeatmap(map, selectedCity)
                        }}>
						<div style="display:flex; align-items: flex-end;">
							<p class="sliderLabel" style="margin-bottom:0px;margin-top:2px">Education facilities</p>
							<img alt="alt" src={darkMode===true?"images/education_dark.png":"images/education_light.png"} width="20" height="20"/>
						</div>
                    </div>
                    <input type=range class={darkMode===true?"darkSlider":"lightSlider"} min=0 max=1 step=any bind:value={eduWeight} on:change={() => {
                        // renderHeatmap(map, selectedCity)
                    }}>
                </div>
            </div>
            <div class="sliderFlex" style="display:flex">
                <div class="weightSlider" style="font-size: {innerWidth<400? "11px":"13.3px"};margin-top:2px">
                    <div style="display:flex">
                        <input type=checkbox class={darkMode===true?"darkCheckbox":"lightCheckbox"} style="margin-bottom:0px;margin-top:18%;margin-right:3px" 
                        bind:checked={foodCheck} 
                        on:change={() => {
                            foodWeight=foodCheck===true?1:0
                            // renderHeatmap(map, selectedCity)
                        }}>
						<div style="display:flex; align-items: flex-end;">
                        	<p class="sliderLabel" style="margin-bottom:0px;margin-top:auto">Restaurants, food trucks, and supermarkets</p><img alt="alt" src={darkMode===true?"images/food_choices_dark.png":"images/food_choices_light.png"} width="20" height="20"/>
						</div>
                    </div>
                    <input type=range class={darkMode===true?"darkSlider":"lightSlider"} min=0 max=1 step=any bind:value={foodWeight} on:change={() => {
                        // renderHeatmap(map, selectedCity)
                    }}>
                </div>
                <div style="display:flex">
                    <button 
                    type="button" 
                    class="resetButton" 
                    style="background-color: {mainBgColorControls};
                    color: {mainDrawColor};
                    border: {borderWidthButtons}px solid {mainBorderColor};
					box-shadow: {darkMode===true?"none":boxShadow}"
                    on:click={() => {
                        renderHeatmap(map, $selectedCity)
                    }}>apply</button>
                    <button 
                    type="button" 
                    class="resetButton" 
                    style="background-color: {mainBgColorControls};
                    color: {mainDrawColor};
                    border: {borderWidthButtons}px solid {mainBorderColor};
					box-shadow: {darkMode===true?"none":boxShadow}"
                    on:click={() => {
                        resetSliders()
                        renderHeatmap(map, $selectedCity)
                    }}>reset</button>
                </div>
            </div>
			<div style="display:flex;">
				<div style="display:flex;font-size: {innerWidth<400? "11px":"13.3px"};">
					<input type=checkbox class={darkMode===true?"darkCheckbox":"lightCheckbox"} style="margin-left:10px;margin-bottom:0px;margin-top:3%;margin-right:3px" 
					bind:checked={tooltipActive} 
					>
					<p style="margin-bottom:0px;margin-top:0px"><span style="transform:translate(0px,5px)" class="material-symbols-outlined">touch_app</span> activate tooltip</p>
				</div>
				<CSVDownloader
						data={$loadedData}
						filename={$selectedCityName}
						bom={true}
					>
						Download data
				</CSVDownloader>
			</div>
        </details>
    </div>
{/if}

<style>

	.tooltipButton {
		font-family: 'Josefin Sans', sans-serif;
	}

	.material-symbols-outlined {
		font-variation-settings:
		'FILL' 0,
		'wght' 300,
		'GRAD' -25,
		'opsz' 48;
	}

	.material-symbols-outlined:hover {
		opacity: 1
		/* font-variation-settings:
		'FILL' 0,
		'wght' 700,
		'GRAD' 200,
		'opsz' 48; */
	}

	/* .material-symbols-outlined-active {
		font-variation-settings:
		'FILL' 1,
		'wght' 300,
		'GRAD' 0,
		'opsz' 48
	} */

	input {
		margin-bottom: 0;
	}

	/* dark slider */

	.darkSlider {
	-webkit-appearance: none;
	height: 2px;
	background: rgb(79, 79, 79);
	outline: none;
	opacity: 1;
	-webkit-transition: .2s;
	transition: opacity .2s;
	max-width: 135px;
	font-family: inherit;
	font-size: inherit;
	-webkit-padding: 0.4em 0;
	padding: 0.2em;
	margin-top: 6px;
	margin-bottom: 5px;
	/* margin: 0 0 0.5em 0; */
	box-sizing: border-box;
	/* border: 1px solid #ccc; */
	border-radius: 0px;
	border: 0px solid #ccc;
	}

	.sliderLabel {
		max-width:100px;
	}

	.darkSlider:hover {
	opacity: 0.8;
	}

	.darkSlider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 12px;
	height: 12px;
	border-radius: 0%;
	background: #fbb61a;
	cursor: pointer;
	
	}

	.darkSlider::-moz-range-thumb {
	width: 15px;
	height: 15;
	background: #fbb61a;
	cursor: pointer;
	}

	.darkSlider::-webkit-slider-runnable-track  {
	-webkit-appearance: none;
	box-shadow: none;
	border: none;
	background: transparent;
	}

	/* light slider */

	.lightSlider {
	-webkit-appearance: none;
	height: 2px;
	background: #1d92c03f;
	outline: none;
	opacity: 1;
	-webkit-transition: .2s;
	transition: opacity .2s;
	max-width: 135px;
	font-family: inherit;
	font-size: inherit;
	-webkit-padding: 0.4em 0;
	padding: 0.2em;
	margin-top: 6px;
	margin-bottom: 5px;
	/* margin: 0 0 0.5em 0; */
	box-sizing: border-box;
	/* border: 1px solid #ccc; */
	border-radius: 0px;
	border: 0px solid #ccc;
	}


	.lightSlider:hover {
	opacity: 0.8;
	}

	.lightSlider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 12px;
	height: 12px;
	border-radius: 0%;
	background: #1d91c0;
	cursor: pointer;
	
	}

	.lightSlider::-moz-range-thumb {
	width: 15px;
	height: 15;
	background: #1d91c0;
	cursor: pointer;
	}

	.lightSlider::-webkit-slider-runnable-track  {
	-webkit-appearance: none;
	box-shadow: none;
	border: none;
	background: transparent;
	}

	/* checkboxes */

	.darkCheckbox {
	/* Add if not using autoprefixer */
	-webkit-appearance: none;
	appearance: none;
	/* For iOS < 15 to remove gradient background */
	/* background-color: rgb(79, 79, 79); */
	/* Not removed via appearance */
	margin: 0;
	font: inherit;
	color: currentColor;
	width: 12px;
	height: 12px;
	border: 1px solid #ccc;
	border-radius: 0.15em;
	transform: translateY(-0.075em);
	border-radius:0px;
	display: grid;
  	place-content: center;
  }

  .darkCheckbox::before {
	content: "";
	width: 7px;
	height: 7px;
	transform: scale(0);
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em #fbb61a;
  }

  .darkCheckbox:checked::before {
	transform: scale(1);
  }

  .lightCheckbox {
	/* Add if not using autoprefixer */
	-webkit-appearance: none;
	appearance: none;
	/* For iOS < 15 to remove gradient background */
	/* background-color: white; */
	/* Not removed via appearance */
	margin: 0;
	font: inherit;
	color: currentColor;
	width: 12px;
	height: 12px;
	border: 1px solid #1d91c0;
	border-radius: 0.15em;
	transform: translateY(-0.075em);
	border-radius:0px;
	display: grid;
  	place-content: center;
	/* box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2); */
  }

  .lightCheckbox::before {
	content: "";
	width: 7px;
	height: 7px;
	transform: scale(0);
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em #1d91c0;
  }

  .lightCheckbox:checked::before {
	transform: scale(1);
  }

	main {
		/* text-align: center; */
		/* padding: 1em;
		max-width: 240px; */
		margin: 0 auto;
	}

	/* #infoPoint:hover {
        font-weight: 900;
        cursor: pointer
	} */

	#infoPoint {
		top: 0px;
		right: 0px;
		cursor:pointer;
		/* text-align: center; */

		/* padding-left:8px;
		padding-right:40px;
		padding-top:38px;
		padding-bottom:5px; */
		/* padding:10px; */
		border-radius:50%;
		width:80px;
		height:80px;
		transform: translate(40px,-40px);
		position: absolute
	}

	#infoPopup {
		position: absolute;
		z-index:100;
		width: 84vw;
		height: 84vh;
		opacity: 0.9;
		text-align: left;
		padding-left: 4%;
		padding-right: 4%;
		overflow: scroll
		/* transform: translate(10vw, 10vh); */
		/* background-color: rgb(20, 20, 20); */
	}

	.sliderFlex {
		margin-bottom: 0;
		margin-top:auto
	}
	.infolink:before {
		content: '?';
		display: inline-block;
		font-family: sans-serif;
		font-weight: bold;
		text-align: center;
		width: 1.8ex;
		height: 1.8ex;
		/* font-size: 1.4ex; */
		line-height: 1.8ex;
		border-radius: 1.2ex;
		margin-right: 4px;
		padding: 1px;
		color: grey;
		background: none;
		border: 1px solid grey;
		text-decoration: none;
	}

	.infolink:hover:before {
		color: white;
		background: grey;
		border-color: white;
		text-decoration: none;
	}

	/* .appTitle {
		
	} */

	.appTitle {
        /* font-weight: 900; */
        font-size: 30px;
		position: absolute;
		text-align:center;
		font-family: 'Josefin Sans', sans-serif;
		/* font-family: halyard-micro, sans-serif !important; */
		font-weight: 700;
		/* text-transform: uppercase; */
		/* text-align: right; */
		/* text-align: right; */
	}	
	
	#cuspLogo {
		position: absolute;
		text-align: right;
	}

	.weightSlider {
		display: flex;
		flex-direction: column;
		/* font-size: 13px; */
		/* line-height: 0.02em; */
		text-align: left;
		margin-left: 10px;
		max-width: 150px;
		vertical-align: text-bottom;
		margin-bottom: 0;
		margin-top:auto;
	}

	.resetButton {
		max-width: 150px;
		margin-bottom: auto;
		margin-top:22%;
		margin-left: 10px;
		text-transform: uppercase;
		cursor: pointer;
	}

	.switchTooltip {
		/* max-width: 150px; */
		margin-bottom: auto;
		/* margin-top:40%; */
		/* margin-left: 10px; */
		padding:5px;
		opacity:0.8;
		border-radius: 3px;
		font-size:14px;
		/* text-transform: uppercase; */
		/* cursor: pointer; */
	}

	#smartphoneFilterButton {
		max-width: 50px;
		height: 100px;
		cursor: pointer;
		text-transform: uppercase;
	}

	#smartphoneFilterButton span {
		display: inline-block;
    	transform: rotate(90deg) translate(0px, 15px);
		 /* Safari */
		-webkit-transform: rotate(90deg) translate(0px, 15px);

		/* Firefox */
		-moz-transform: rotate(90deg) translate(0px, 15px);

		/* IE */
		-ms-transform: rotate(90deg) translate(0px, 15px);

		/* Opera */
		-o-transform: rotate(90deg) translate(0px, 15px);
	}

	.closeButton {
		position:absolute; 
		max-height:27px;
		font-weight:900;
		cursor:pointer;					
	}

	.label:first-child {
		float: left;
	}
	.label:last-child {
		float: right;
	}
	#console {
		position: absolute;
		/* width: 25vw; */
		/* width: 300px; */
		max-width: 100vw;
		/* margin: 10px; */
		padding: 10px 20px;
		text-align: left;
		opacity: 0.95;
		/* font-size: 15.3px; */
		border-width: 2px;
		/* background-color: white; */
	}

	#access {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 100%;
	}

	/* h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	} */

	/* @media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */

	#citiesSelect {
      cursor:pointer;
      max-width: 215px;
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 16px;
      text-transform: uppercase;
	  /* border-width: 2px; */
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }
	
	.citiesSelect {
      cursor:pointer;
      max-width: 215px;
	  min-width: 215px;
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 14px;
      /* text-transform: uppercase; */
	  border-width: 2px;
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }

	/* #citiesSelect:hover {
		background-color: #fbb61a;
	} */

	.mapboxgl-popup-content {
	color: #ccc;
	}

	td {
	color: #ccc;
	border-bottom:1px solid black;
	border-bottom-width: 0px;
	z-index:0
	}

	.tableSep {
	border-left:1px solid #ccc;
	text-align: center;
	z-index:1
	}

	th {
	text-transform: uppercase;
	color: #ccc;
	border: none;
	}

	table, th, td {
	border-collapse: collapse;
	font-size:12px
	}

	.rounded-rect {
	background: black;
	opacity: 0.7;
	border-radius: 10px;
	box-shadow: 0 0 50px -25px black;
	}
	
	.flex-center {
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	}
	
	.flex-center.left {
	left: 0px;
	}
	
	.flex-center.right {
	right: 0px;
	}
	
	.sidebar-content {
	position: absolute;
	width: 95%;
	height: 95%;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 32px;
	color: #ccc;
	}
	
	.sidebar-toggle {
	position: absolute;
	width: 1.3em;
	height: 1.3em;
	overflow: visible;
	display: flex;
	justify-content: center;
	align-items: center;
	}
	
	.sidebar-toggle.left {
	right: -1.5em;
	}
	
	.sidebar-toggle.right {
	left: -1.5em;
	}
	
	.sidebar-toggle:hover {
	color: orange;
	cursor: pointer;
	}
	
	.sidebar {
	transition: transform 1s;
	z-index: 1;
	width: 400px;
	height: 100%;
	}
	
	/*
	The sidebar styling has them "expanded" by default, we use CSS transforms to push them offscreen
	The toggleSidebar() function removes this class from the element in order to expand it.
	*/
	.left.collapsed {
	transform: translateX(-395px);
	}
	
	.right.collapsed {
	transform: translateX(395px);
	}
</style>